/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Fiddy API
 * Documentation interne — **nesso dev only**.

## Auth

Deux headers requis sur tous les endpoints protégés :
- `Authorization: Bearer <JWT>` — obtenu via `POST /auth` (expire après 30 min, refresh via `POST /auth/refresh`)
- `App-Id: <workspace_app_id>`

## Conventions

- Pagination : `data[]` + objet `pagination`
- Erreurs : schéma `HttpError` (`code` + `message`)
- Validation : `422` avec tableau `violations`

## Docs

- Accéder à [Swagger](/)
- Accéder à [Scalar](/scalar)

 * OpenAPI spec version: 1.0.0
 */
export interface SimpleJWTTokenModel {
  token: string;
}

export interface JWTTokenModel {
  token: string;
  refreshToken: string;
  refreshTokenExpiresAt: number;
}

export interface JWTRefreshTokenModel {
  refreshToken: string;
}

export interface AutoLoginRequestModel {
  /** One-time token received by email (magic link) */
  token: string;
}

export interface ForgotPasswordSubmitBodyModel {
  /** @pattern /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/ */
  plainPassword: string;
}

export interface UserUserImportModel {
  /**
   * User email
   * @maxLength 255
   */
  email: string;
  /**
   * User plain password
   * @minLength 8
   * @nullable
   * @pattern ^((?=.*[a-z])(?=.*[A-Z])(?=.*\d).+)$
   */
  plainPassword: string | null;
  userWorkspace: UserWorkspaceUserImportModel;
  /**
   * User firstname
   * @maxLength 50
   */
  firstname: string;
  /**
   * User lastname
   * @maxLength 50
   */
  lastname: string;
  /** Send welcome email if true (front user only) */
  emailNotification: boolean;
}

/**
 * User max role
 */
export type UserWorkspaceUserImportModelMaxRole = typeof UserWorkspaceUserImportModelMaxRole[keyof typeof UserWorkspaceUserImportModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceUserImportModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export interface UserWorkspaceUserImportModel {
  /** User max role */
  maxRole: UserWorkspaceUserImportModelMaxRole;
  /**
   * The company unique code to which the user belongs
   * @nullable
   */
  companyUniqueCode?: string | null;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /**
   * User phone number
   * @maxLength 20
   * @nullable
   */
  phone?: string | null;
  /**
   * Comment about the user
   * @nullable
   */
  comment?: string | null;
  /**
   * Additional customizable comment about the user
   * @nullable
   */
  comment2?: string | null;
  /**
   * Additional customizable comment about the user
   * @nullable
   */
  comment3?: string | null;
}

/**
 * User max role
 */
export type UserWorkspaceMeReadModelMaxRole = typeof UserWorkspaceMeReadModelMaxRole[keyof typeof UserWorkspaceMeReadModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceMeReadModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export type UserWorkspaceMeReadModelCompany = CompanyMeReadModel | null;

/**
 * User status
 */
export type UserWorkspaceMeReadModelStatus = typeof UserWorkspaceMeReadModelStatus[keyof typeof UserWorkspaceMeReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceMeReadModelStatus = {
  userstatusunregistered: 'user.status.unregistered',
  userstatusregistered: 'user.status.registered',
  userstatusblocked: 'user.status.blocked',
  userstatusinactive: 'user.status.inactive',
} as const;

export interface UserWorkspaceMeReadModel {
  readonly id?: number;
  workspace: WorkspaceMeReadModel;
  /** User roles */
  roles: (string | null)[];
  /** User max role */
  maxRole: UserWorkspaceMeReadModelMaxRole;
  company?: UserWorkspaceMeReadModelCompany;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /** User creation date */
  createdAt: string;
  /** User status */
  status?: UserWorkspaceMeReadModelStatus;
  points: PointMeReadModel[];
  /** true if user is connected to the current workspace */
  active: boolean;
  /**
   * User phone number
   * @maxLength 20
   * @nullable
   */
  phone?: string | null;
  /**
   * User registration date
   * @nullable
   */
  registeredAt: string | null;
  /** Total number of logins for this user on this workspace */
  loginCount: number;
  loginCountPerMonth: ValuePerMonthMeReadModel[];
  readonly passwordNeedToBeChanged?: boolean;
}

/**
 * User max role
 */
export type UserWorkspaceUserReadModelMaxRole = typeof UserWorkspaceUserReadModelMaxRole[keyof typeof UserWorkspaceUserReadModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceUserReadModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export type UserWorkspaceUserReadModelCompany = CompanyUserReadModel | null;

/**
 * User status
 */
export type UserWorkspaceUserReadModelStatus = typeof UserWorkspaceUserReadModelStatus[keyof typeof UserWorkspaceUserReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceUserReadModelStatus = {
  userstatusunregistered: 'user.status.unregistered',
  userstatusregistered: 'user.status.registered',
  userstatusblocked: 'user.status.blocked',
  userstatusinactive: 'user.status.inactive',
} as const;

export interface UserWorkspaceUserReadModel {
  readonly id?: number;
  /** User max role */
  maxRole: UserWorkspaceUserReadModelMaxRole;
  company?: UserWorkspaceUserReadModelCompany;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /** User creation date */
  createdAt: string;
  /** User status */
  status?: UserWorkspaceUserReadModelStatus;
  points: PointUserReadModel[];
  /** true if user is connected to the current workspace */
  active: boolean;
  /**
   * User phone number
   * @maxLength 20
   * @nullable
   */
  phone?: string | null;
  /**
   * User registration date
   * @nullable
   */
  registeredAt: string | null;
  /** Number of sales reporting directly to this user, across every sales hierarchy they lead */
  salesHierarchyDirectReportsCount: number;
  /** Total number of logins for this user on this workspace */
  loginCount: number;
  loginCountPerMonth: ValuePerMonthUserReadModel[];
  /**
   * Comment about the user
   * @nullable
   */
  comment?: string | null;
  /**
   * Additional customizable comment about the user
   * @nullable
   */
  comment2?: string | null;
  /**
   * Additional customizable comment about the user
   * @nullable
   */
  comment3?: string | null;
  attachedCompanies?: CompanyUserReadModel[];
  readonly passwordNeedToBeChanged?: boolean;
}

/**
 * User max role
 */
export type UserWorkspaceUserCollectionReadModelMaxRole = typeof UserWorkspaceUserCollectionReadModelMaxRole[keyof typeof UserWorkspaceUserCollectionReadModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceUserCollectionReadModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export type UserWorkspaceUserCollectionReadModelCompany = CompanyUserCollectionReadModel | null;

/**
 * User status
 */
export type UserWorkspaceUserCollectionReadModelStatus = typeof UserWorkspaceUserCollectionReadModelStatus[keyof typeof UserWorkspaceUserCollectionReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceUserCollectionReadModelStatus = {
  userstatusunregistered: 'user.status.unregistered',
  userstatusregistered: 'user.status.registered',
  userstatusblocked: 'user.status.blocked',
  userstatusinactive: 'user.status.inactive',
} as const;

export interface UserWorkspaceUserCollectionReadModel {
  readonly id?: number;
  /** User max role */
  maxRole: UserWorkspaceUserCollectionReadModelMaxRole;
  company?: UserWorkspaceUserCollectionReadModelCompany;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /** User creation date */
  createdAt: string;
  /** User status */
  status?: UserWorkspaceUserCollectionReadModelStatus;
  /** true if user is connected to the current workspace */
  active: boolean;
  /**
   * User phone number
   * @maxLength 20
   * @nullable
   */
  phone?: string | null;
  /**
   * User registration date
   * @nullable
   */
  registeredAt: string | null;
  /**
   * Comment about the user
   * @nullable
   */
  comment?: string | null;
  /**
   * Additional customizable comment about the user
   * @nullable
   */
  comment2?: string | null;
  /**
   * Additional customizable comment about the user
   * @nullable
   */
  comment3?: string | null;
}

/**
 * User max role
 */
export type UserWorkspaceCompanyReadModelMaxRole = typeof UserWorkspaceCompanyReadModelMaxRole[keyof typeof UserWorkspaceCompanyReadModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceCompanyReadModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export interface UserWorkspaceCompanyReadModel {
  user: UserCompanyReadModel;
  /** User max role */
  maxRole?: UserWorkspaceCompanyReadModelMaxRole;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
}

export type WorkspaceWorkspaceReadModelCurrentLogicWorkspace = LogicWorkspaceWorkspaceReadModel | null;

/**
 * Workspace status
 * @maxLength 20
 */
export type WorkspaceWorkspaceReadModelStatus = typeof WorkspaceWorkspaceReadModelStatus[keyof typeof WorkspaceWorkspaceReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceWorkspaceReadModelStatus = {
  active: 'active',
  draft: 'draft',
  misconfigured: 'misconfigured',
} as const;

export interface WorkspaceWorkspaceReadModel {
  /** Workspace ID */
  readonly id: number;
  /**
   * Workspace name
   * @maxLength 50
   */
  name: string;
  currentLogicWorkspace: WorkspaceWorkspaceReadModelCurrentLogicWorkspace;
  isMaintenance?: boolean;
  /**
   * Workspace domain
   * @maxLength 255
   * @pattern ^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$
   */
  domain: string;
  /** Workspace preprod domain, used by the front-user preprod link */
  preprodDomain?: string;
  /**
   * Workspace status
   * @maxLength 20
   */
  status?: WorkspaceWorkspaceReadModelStatus;
  typologies?: TypologyWorkspaceReadModel[];
  activeShops: ShopWorkspaceReadModel[];
  /** Number of active games */
  activeGamesCount: number;
}

export interface TypologyTypologyWriteModel {
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
  /**
   * Coefficient of the typology (conversion euros => points)
   * @minimum 0
   */
  pointCoeff: number;
  /** Typology used by default */
  isDefault: boolean;
}

export interface CompanyCompanyImportModel {
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   * @pattern ^([0-9]*)$
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  /**
   * Company address line 1
   * @minLength 7
   * @maxLength 255
   */
  addressLine1: string;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @minLength 4
   * @maxLength 20
   */
  zipcode: string;
  /**
   * Company city
   * @maxLength 100
   */
  city: string;
  /** Company country alpha3 */
  countryAlpha3: string;
  /**
   * User unique code(s) to link to the company, separated by "|" for multiple
   * @nullable
   */
  responsiblesUniqueCodes?: string | null;
  /**
   * The typology name to which the company belongs
   * @nullable
   */
  typologyName?: string | null;
  /**
   * Coefficient used to calculate points (depending conversion type)
   * @nullable
   */
  pointCoeff?: number | null;
  /**
   * Comment about the company
   * @nullable
   */
  comment?: string | null;
}

export type PointInsightUserMeReadModelTypeLabel = typeof PointInsightUserMeReadModelTypeLabel[keyof typeof PointInsightUserMeReadModelTypeLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointInsightUserMeReadModelTypeLabel = {
  CORE: 'CORE',
  IMPORTED: 'IMPORTED',
  SPENT: 'SPENT',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  BOOSTER: 'BOOSTER',
} as const;

export interface PointInsightUserMeReadModel {
  /** Points amount */
  amount: number;
  /**
   * Points label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  typeLabel: PointInsightUserMeReadModelTypeLabel;
  /**
   * Points expiration date
   * @nullable
   */
  expirationDate?: string | null;
  /** Points value date */
  valueDate: string;
}

/**
 * Shop type
 * @maxLength 10
 */
export type ShopShopReadModelType = typeof ShopShopReadModelType[keyof typeof ShopShopReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShopShopReadModelType = {
  provider: 'provider',
  reward: 'reward',
  custom: 'custom',
} as const;

export type ShopShopReadModelBanner = MediaShopReadModel | null;

export type ShopShopReadModelShopWorkspace = ShopWorkspaceShopReadModel | null;

export interface ShopShopReadModel {
  /** Shop ID */
  readonly id: number;
  /**
   * Shop name
   * @maxLength 100
   */
  name: string;
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName: string;
  /**
   * Shop description (label)
   * @maxLength 255
   */
  description: string;
  /**
   * Shop type
   * @maxLength 10
   */
  type: ShopShopReadModelType;
  logo: MediaShopReadModel;
  banner?: ShopShopReadModelBanner;
  shopWorkspace?: ShopShopReadModelShopWorkspace;
  /** Shop maintenance status */
  isMaintenance: boolean;
  /**
   * @maxLength 255
   * @nullable
   */
  operationalContact?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  technicalContact?: string | null;
}

export interface ShopWorkspaceShopReadModel {
  /** Shop Workspace ID */
  readonly id: number;
  /**
   * Minimum point before provider can be used
   * @minimum 0
   */
  minPoint?: number;
  /**
   * Marge coefficient
   * @minimum 1
   */
  coefficient?: number;
  /**
   * Shop opening date
   * @nullable
   */
  shopOpeningDate?: string | null;
  /**
   * Shop closing date
   * @nullable
   */
  shopClosingDate?: string | null;
  /** Shop workspace is active */
  isActive: boolean;
  isActivable?: boolean;
}

export type ViolationsModelItem = {
  /** The invalid property */
  property: string;
  /** The invalid message label */
  message: string;
  /** The invalid message detail */
  detail: string;
};

export type ViolationsModel = ViolationsModelItem[];

export interface ImportModel {
  /** Number of lines imported */
  linesImported: number;
}

export interface ImportQueueModel {
  /** Indicates if the import was accepted */
  success: boolean;
}

export type MediaUploadModelType = typeof MediaUploadModelType[keyof typeof MediaUploadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaUploadModelType = {
  layout: 'layout',
  legal: 'legal',
  assets: 'assets',
  external: 'external',
  proof: 'proof',
} as const;

export interface MediaUploadModel {
  file: Blob;
  type: MediaUploadModelType;
}

export type GroupedLocalesModelGroupedLocalesTranslations = {[key: string]: string};

export type GroupedLocalesModelGroupedLocales = {[key: string]: {
  translations?: GroupedLocalesModelGroupedLocalesTranslations;
}};

export interface GroupedLocalesModel {
  groupedLocales?: GroupedLocalesModelGroupedLocales;
}

export type GroupedWorkspaceConfigModelGroupedConfigsOneOf = {[key: string]: {[key: string]: string}};

export type GroupedWorkspaceConfigModelGroupedConfigs = GroupedWorkspaceConfigModelGroupedConfigsOneOf | null;

export interface GroupedWorkspaceConfigModel {
  groupedConfigs: GroupedWorkspaceConfigModelGroupedConfigs;
}

export interface SwitchWorkspaceModel {
  workspaceId: number;
  uniqueCode: string;
}

export interface PasswordUpdateModel {
  newPassword: string;
  currentPassword?: string;
}

export interface LogModel {
  message: string;
}

export interface HelpRequestModel {
  message: string;
  reason: string;
}

export interface PaginatedResponseModel {
  data: unknown[];
  pagination: PaginationModel;
}

export interface PaginationModel {
  first: number;
  current: number;
  last: number;
  previous: number;
  next: number;
  totalItems: number;
  perPage: number;
}

export type HttpErrorModelTraceItem = {
  args: unknown[];
  file: string;
  function: string;
  class?: string;
  line: number;
  type?: string;
};

export interface HttpErrorModel {
  code: number;
  message: string;
  trace?: HttpErrorModelTraceItem[];
}

export interface UnprocessableEntityModel {
  code: number;
  message: string;
  violations: ViolationsModel;
}

export interface ApiTokenApiTokenReadModel {
  /** Api Token ID */
  readonly id: number;
  /**
   * Name of the token
   * @minLength 3
   * @maxLength 100
   */
  name: string;
  /** Date and time when the token was created */
  createdAt: string;
}

export interface ApiTokenApiTokenWriteModel {
  /**
   * Name of the token
   * @minLength 3
   * @maxLength 100
   */
  name: string;
}

export interface BoosterBoosterCollectionReadModel {
  /** Booster ID */
  readonly id: number;
  /**
   * Title of the booster
   * @maxLength 255
   */
  title: string;
  /**
   * Description of the booster
   * @nullable
   */
  description?: string | null;
  /** Start date of the booster */
  startDate: string;
  /** End date of the booster */
  endDate: string;
  /**
   * Current status of the booster
   * @nullable
   */
  status: string | null;
  readonly referencesCount?: number;
}

export interface BoosterBoosterReadModel {
  /** Booster ID */
  readonly id: number;
  /**
   * Title of the booster
   * @maxLength 255
   */
  title: string;
  /**
   * Description of the booster
   * @nullable
   */
  description?: string | null;
  /** Start date of the booster */
  startDate: string;
  /** End date of the booster */
  endDate: string;
  boosterReferences?: BoosterReferenceBoosterReadModel[];
  /**
   * Current status of the booster
   * @nullable
   */
  status: string | null;
}

export interface BoosterBoosterWriteModel {
  /**
   * Title of the booster
   * @maxLength 255
   */
  title: string;
  /**
   * Description of the booster
   * @nullable
   */
  description?: string | null;
  /** Start date of the booster */
  startDate: string;
  /** End date of the booster */
  endDate: string;
  boosterReferences?: BoosterReferenceBoosterWriteModel[];
}

export interface BoosterBoosterWriteJsonMergePatchModel {
  /**
   * Title of the booster
   * @maxLength 255
   */
  title?: string;
  /**
   * Description of the booster
   * @nullable
   */
  description?: string | null;
  /** Start date of the booster */
  startDate?: string;
  /** End date of the booster */
  endDate?: string;
  boosterReferences?: BoosterReferenceBoosterWriteModel[];
}

export interface BoosterPointCollectionReadModel {
  /** Booster ID */
  readonly id: number;
  /**
   * Title of the booster
   * @maxLength 255
   */
  title: string;
}

export interface BoosterPointReadModel {
  /** Booster ID */
  readonly id: number;
  /**
   * Title of the booster
   * @maxLength 255
   */
  title: string;
}

export interface BoosterReferenceReadModel {
  /** Start date of the booster */
  startDate: string;
  /** End date of the booster */
  endDate: string;
}

export interface BoosterReferenceBoosterReadModel {
  /** BoosterReference ID */
  readonly id?: number;
  reference: ReferenceBoosterReadModel;
  /**
   * Minimum cumulated quantity (included) from which the coefficient applies
   * @minimum 0
   */
  minQuantity?: number;
  /**
   * Maximum cumulated quantity (included) up to which the coefficient applies, null for no upper bound
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  maxQuantity?: number | null;
  /**
   * Points multiplier applied on quantities of this tier, 0 gives no boosted points
   * @minimum 0
   */
  coefficient: number;
  /** @nullable */
  readonly boostedPointValue?: number | null;
}

export interface BoosterReferenceBoosterWriteModel {
  /** Boosted reference */
  reference: string;
  /**
   * Minimum cumulated quantity (included) from which the coefficient applies
   * @minimum 0
   */
  minQuantity?: number;
  /**
   * Maximum cumulated quantity (included) up to which the coefficient applies, null for no upper bound
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  maxQuantity?: number | null;
  /**
   * Points multiplier applied on quantities of this tier, 0 gives no boosted points
   * @minimum 0
   */
  coefficient: number;
}

export interface BoosterReferenceReferenceReadModel {
  /**
   * Minimum cumulated quantity (included) from which the coefficient applies
   * @minimum 0
   */
  minQuantity?: number;
  /**
   * Maximum cumulated quantity (included) up to which the coefficient applies, null for no upper bound
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  maxQuantity?: number | null;
  /**
   * Points multiplier applied on quantities of this tier, 0 gives no boosted points
   * @minimum 0
   */
  coefficient: number;
  /** @nullable */
  readonly boostedPointValue?: number | null;
}

export interface CartHealthcheckCartHealthcheckReadModel {
  items: CartHealthcheckItemCartHealthcheckReadModel[];
  /** Whether every item in the cart is valid */
  isValid: boolean;
}

export interface CartHealthcheckCartHealthcheckWriteModel {
  items: CartHealthcheckItemCartHealthcheckWriteModel[];
}

export interface CartHealthcheckItemCartHealthcheckReadModel {
  /**
   * Product IRI
   * @nullable
   */
  product: string | null;
  /**
   * Requested quantity
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  quantity: number | null;
  /**
   * Issue code found for this item, checked in order, null if valid
   * @nullable
   */
  issue?: string | null;
  readonly isValid?: boolean;
}

export interface CartHealthcheckItemCartHealthcheckWriteModel {
  /**
   * Product IRI
   * @nullable
   */
  product: string | null;
  /**
   * Requested quantity
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  quantity: number | null;
}

/**
 * Changelog tag
 */
export type ChangelogChangelogReadModelTag = typeof ChangelogChangelogReadModelTag[keyof typeof ChangelogChangelogReadModelTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogChangelogReadModelTag = {
  feature: 'feature',
  improvement: 'improvement',
  bugfix: 'bugfix',
} as const;

export type ChangelogChangelogReadModelMedia = MediaChangelogReadModel | null;

/**
 * Target users group for this changelog entry
 */
export type ChangelogChangelogReadModelTarget = typeof ChangelogChangelogReadModelTarget[keyof typeof ChangelogChangelogReadModelTarget];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogChangelogReadModelTarget = {
  admins: 'admins',
  sales: 'sales',
  users: 'users',
} as const;

/**
 * Retrieve the list of changelog entries
 */
export interface ChangelogChangelogReadModel {
  /** Changelog ID */
  readonly id: number;
  /** Changelog title */
  title: string;
  /** Changelog tag */
  tag: ChangelogChangelogReadModelTag;
  /** Changelog details */
  description: string;
  media?: ChangelogChangelogReadModelMedia;
  /** Target users group for this changelog entry */
  target: ChangelogChangelogReadModelTarget;
  /** Creation date */
  createdAt?: string;
}

/**
 * Changelog tag
 */
export type ChangelogChangelogWriteModelTag = typeof ChangelogChangelogWriteModelTag[keyof typeof ChangelogChangelogWriteModelTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogChangelogWriteModelTag = {
  feature: 'feature',
  improvement: 'improvement',
  bugfix: 'bugfix',
} as const;

/**
 * Target users group for this changelog entry
 */
export type ChangelogChangelogWriteModelTarget = typeof ChangelogChangelogWriteModelTarget[keyof typeof ChangelogChangelogWriteModelTarget];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogChangelogWriteModelTarget = {
  admins: 'admins',
  sales: 'sales',
  users: 'users',
} as const;

/**
 * Create a new changelog entry
 */
export interface ChangelogChangelogWriteModel {
  /** Changelog title */
  title: string;
  /** Changelog tag */
  tag: ChangelogChangelogWriteModelTag;
  /** Changelog details */
  description: string;
  /**
   * IRI of the related media
   * @nullable
   */
  media?: string | null;
  /** Target users group for this changelog entry */
  target: ChangelogChangelogWriteModelTarget;
}

/**
 * Changelog tag
 */
export type ChangelogChangelogWriteJsonMergePatchModelTag = typeof ChangelogChangelogWriteJsonMergePatchModelTag[keyof typeof ChangelogChangelogWriteJsonMergePatchModelTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogChangelogWriteJsonMergePatchModelTag = {
  feature: 'feature',
  improvement: 'improvement',
  bugfix: 'bugfix',
} as const;

/**
 * Target users group for this changelog entry
 */
export type ChangelogChangelogWriteJsonMergePatchModelTarget = typeof ChangelogChangelogWriteJsonMergePatchModelTarget[keyof typeof ChangelogChangelogWriteJsonMergePatchModelTarget];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChangelogChangelogWriteJsonMergePatchModelTarget = {
  admins: 'admins',
  sales: 'sales',
  users: 'users',
} as const;

/**
 * Partially update a changelog entry
 */
export interface ChangelogChangelogWriteJsonMergePatchModel {
  /** Changelog title */
  title?: string;
  /** Changelog tag */
  tag?: ChangelogChangelogWriteJsonMergePatchModelTag;
  /** Changelog details */
  description?: string;
  /**
   * IRI of the related media
   * @nullable
   */
  media?: string | null;
  /** Target users group for this changelog entry */
  target?: ChangelogChangelogWriteJsonMergePatchModelTarget;
}

/**
 * Company status (read-only, computed from managers statuses)
 */
export type CompanyCompanyCollectionReadModelStatus = typeof CompanyCompanyCollectionReadModelStatus[keyof typeof CompanyCompanyCollectionReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyCompanyCollectionReadModelStatus = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type CompanyCompanyCollectionReadModelTypology = TypologyCompanyCollectionReadModel | null;

export type CompanyCompanyCollectionReadModelLastStepReached = LogicTypeStepCompanyCollectionReadModel | null;

export interface CompanyCompanyCollectionReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   * @pattern ^([0-9]*)$
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  /**
   * Company address line 1
   * @minLength 7
   * @maxLength 255
   */
  addressLine1: string;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @minLength 4
   * @maxLength 20
   */
  zipcode: string;
  /**
   * Company city
   * @maxLength 100
   */
  city: string;
  country?: CountryCompanyCollectionReadModel;
  /** Company creation date */
  createdAt: string;
  /** Company status (read-only, computed from managers statuses) */
  status: CompanyCompanyCollectionReadModelStatus;
  /**
   * Datetime where the first managed completed registration was done
   * @nullable
   */
  registeredAt?: string | null;
  logicStepHistory?: LogicTypeStepHistoryCompanyCollectionReadModel[];
  typology?: CompanyCompanyCollectionReadModelTypology;
  /** CA amount of the company */
  caAmount: number;
  /** Total of acquired points */
  acquiredPoints: number;
  /**
   * Coefficient used to calculate points (depending conversion type)
   * @nullable
   */
  pointCoeff?: number | null;
  /**
   * Comment about the company
   * @nullable
   */
  comment?: string | null;
  responsibles?: UserWorkspaceCompanyCollectionReadModel[];
  readonly lastStepReached?: CompanyCompanyCollectionReadModelLastStepReached;
  /** Balance of the company */
  readonly balance: number;
}

/**
 * Company status (read-only, computed from managers statuses)
 */
export type CompanyCompanyReadModelStatus = typeof CompanyCompanyReadModelStatus[keyof typeof CompanyCompanyReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyCompanyReadModelStatus = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type CompanyCompanyReadModelTypology = TypologyCompanyReadModel | null;

export type CompanyCompanyReadModelLastStepReached = LogicTypeStepCompanyReadModel | null;

export interface CompanyCompanyReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   * @pattern ^([0-9]*)$
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  /**
   * Company address line 1
   * @minLength 7
   * @maxLength 255
   */
  addressLine1: string;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @minLength 4
   * @maxLength 20
   */
  zipcode: string;
  /**
   * Company city
   * @maxLength 100
   */
  city: string;
  country?: CountryCompanyReadModel;
  /** Company creation date */
  createdAt: string;
  userWorkspaces: UserWorkspaceCompanyReadModel[];
  companyHistory: CompanyHistoryCompanyReadModel[];
  /** Company status (read-only, computed from managers statuses) */
  status: CompanyCompanyReadModelStatus;
  /**
   * Datetime where the first managed completed registration was done
   * @nullable
   */
  registeredAt?: string | null;
  logicStepHistory?: LogicTypeStepHistoryCompanyReadModel[];
  typology?: CompanyCompanyReadModelTypology;
  points: PointCompanyReadModel[];
  pointsPerMonth: ValuePerMonthCompanyReadModel[];
  /** CA amount of the company */
  caAmount: number;
  /** Total of acquired points */
  acquiredPoints: number;
  /** Total of spent points */
  spentPoints: number;
  perfsPerMonth: ValuePerMonthCompanyReadModel[];
  orders?: OrderCompanyReadModel[];
  targetStatuses?: LogicTypeTargetStatusCompanyReadModel[];
  /**
   * Coefficient used to calculate points (depending conversion type)
   * @nullable
   */
  pointCoeff?: number | null;
  /**
   * Comment about the company
   * @nullable
   */
  comment?: string | null;
  responsibles?: UserWorkspaceCompanyReadModel[];
  readonly lastStepReached?: CompanyCompanyReadModelLastStepReached;
  /** Balance of the company */
  readonly balance: number;
}

export interface CompanyCompanyUpdateModel {
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   * @pattern ^([0-9]*)$
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  /**
   * Company address line 1
   * @minLength 7
   * @maxLength 255
   */
  addressLine1: string;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @minLength 4
   * @maxLength 20
   */
  zipcode: string;
  /**
   * Company city
   * @maxLength 100
   */
  city: string;
  /** Company country alpha3 */
  countryAlpha3?: string;
  /**
   * User unique code(s) to link to the company, separated by "|" for multiple
   * @nullable
   */
  responsiblesUniqueCodes?: string | null;
  /**
   * The typology name to which the company belongs
   * @nullable
   */
  typologyName?: string | null;
  /**
   * Coefficient used to calculate points (depending conversion type)
   * @nullable
   */
  pointCoeff?: number | null;
  /**
   * Comment about the company
   * @nullable
   */
  comment?: string | null;
}

export interface CompanyCompanyUpdateJsonMergePatchModel {
  /**
   * Company name
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   * @pattern ^([0-9]*)$
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  /**
   * Company address line 1
   * @minLength 7
   * @maxLength 255
   */
  addressLine1?: string;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @minLength 4
   * @maxLength 20
   */
  zipcode?: string;
  /**
   * Company city
   * @minLength 1
   * @maxLength 100
   */
  city?: string;
  /** Company country alpha3 */
  countryAlpha3?: string;
  /**
   * User unique code(s) to link to the company, separated by "|" for multiple
   * @nullable
   */
  responsiblesUniqueCodes?: string | null;
  /**
   * The typology name to which the company belongs
   * @nullable
   */
  typologyName?: string | null;
  /**
   * Coefficient used to calculate points (depending conversion type)
   * @nullable
   */
  pointCoeff?: number | null;
  /**
   * Comment about the company
   * @nullable
   */
  comment?: string | null;
}

export interface CompanyInsightDashboardReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /** Total of acquired points */
  acquiredPoints: number;
}

export interface CompanyInsightPerformanceReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /** CA amount of the company */
  caAmount: number;
}

export interface CompanyInsightPointReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /** Total of acquired points */
  acquiredPoints: number;
}

export interface CompanyLogicTypeStepHistoryCollectionReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
}

export interface CompanyLogicTypeTargetStatusCollectionReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
}

/**
 * Company status (read-only, computed from managers statuses)
 */
export type CompanyMeReadModelStatus = typeof CompanyMeReadModelStatus[keyof typeof CompanyMeReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CompanyMeReadModelStatus = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type CompanyMeReadModelLastStepReached = LogicTypeStepMeReadModel | null;

export interface CompanyMeReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   * @pattern ^([0-9]*)$
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  /**
   * Company address line 1
   * @minLength 7
   * @maxLength 255
   */
  addressLine1: string;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @minLength 4
   * @maxLength 20
   */
  zipcode: string;
  /**
   * Company city
   * @maxLength 100
   */
  city: string;
  country?: CountryMeReadModel;
  /** Company creation date */
  createdAt: string;
  /** Company status (read-only, computed from managers statuses) */
  status: CompanyMeReadModelStatus;
  /**
   * Datetime where the first managed completed registration was done
   * @nullable
   */
  registeredAt?: string | null;
  logicStepHistory?: LogicTypeStepHistoryMeReadModel[];
  /** CA amount of the company */
  caAmount: number;
  targetStatuses?: LogicTypeTargetStatusMeReadModel[];
  readonly lastStepReached?: CompanyMeReadModelLastStepReached;
  /** Balance of the company */
  readonly balance: number;
}

export interface CompanyOrderCollectionReadModel {
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
}

export type CompanyOrderReadModelTypology = TypologyOrderReadModel | null;

export interface CompanyOrderReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company address line 1
   * @minLength 7
   * @maxLength 255
   */
  addressLine1: string;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @minLength 4
   * @maxLength 20
   */
  zipcode: string;
  /**
   * Company city
   * @maxLength 100
   */
  city: string;
  country?: CountryOrderReadModel;
  typology?: CompanyOrderReadModelTypology;
  responsibles?: UserWorkspaceOrderReadModel[];
}

export interface CompanyPerformanceCollectionReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
}

export interface CompanyPerformanceReadModel {
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
}

export interface CompanyPointCollectionReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
}

export interface CompanyPointReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
}

export interface CompanyPurchaseProofCollectionReadModel {
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
}

export interface CompanySegmentMemberReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
}

export interface CompanyUserCollectionReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  /**
   * Full names of the responsibles
   * @nullable
   */
  responsiblesFullName?: (string | null)[] | null;
}

export type CompanyUserReadModelLastStepReached = LogicTypeStepUserReadModel | null;

export interface CompanyUserReadModel {
  /** Company ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   */
  name: string;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode: string;
  logicStepHistory?: LogicTypeStepHistoryUserReadModel[];
  readonly lastStepReached?: CompanyUserReadModelLastStepReached;
}

export interface CompanyHistoryCompanyReadModel {
  /**
   * Company field that was updated
   * @maxLength 255
   */
  property: string;
  /** Company field old value */
  previousValue: string;
  /** Company field new value */
  newValue: string;
  /** History creation date */
  createdAt: string;
  madeByUser: UserCompanyReadModel;
}

export interface CompanyResponsibleCompanyResponsibleReadModel {
  responsible: UserWorkspaceCompanyResponsibleReadModel;
}

export interface CompanyResponsibleCompanyResponsibleWriteModel {
  /** IRI of the responsible */
  responsible: string;
}

/**
 * Config type
 * @maxLength 20
 */
export type ConfigConfigReadModelType = typeof ConfigConfigReadModelType[keyof typeof ConfigConfigReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfigConfigReadModelType = {
  core: 'core',
  media: 'media',
  style: 'style',
  shop: 'shop',
  link: 'link',
} as const;

export interface ConfigConfigReadModel {
  /** Config ID */
  readonly id?: number;
  /**
   * Config type
   * @maxLength 20
   */
  type: ConfigConfigReadModelType;
  /**
   * Config key
   * @maxLength 30
   */
  key: string;
  /** If this config need to be used on public views (like auth page) */
  isPublic: boolean;
  /** If this config is secret (like API keys) */
  isSecret: boolean;
  /**
   * Config title
   * @maxLength 255
   */
  title: string;
  /**
   * Config description
   * @maxLength 255
   */
  description: string;
}

/**
 * Config type
 * @maxLength 20
 */
export type ConfigConfigWriteModelType = typeof ConfigConfigWriteModelType[keyof typeof ConfigConfigWriteModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfigConfigWriteModelType = {
  core: 'core',
  media: 'media',
  style: 'style',
  shop: 'shop',
  link: 'link',
} as const;

export interface ConfigConfigWriteModel {
  /**
   * Config type
   * @maxLength 20
   */
  type: ConfigConfigWriteModelType;
  /**
   * Config key
   * @maxLength 30
   */
  key: string;
  /** If this config need to be used on public views (like auth page) */
  isPublic: boolean;
  /** If this config is secret (like API keys) */
  isSecret: boolean;
  /**
   * Config title
   * @maxLength 255
   */
  title: string;
  /**
   * Config description
   * @maxLength 255
   */
  description: string;
}

/**
 * Config type
 * @maxLength 20
 */
export type ConfigWorkspaceConfigReadModelType = typeof ConfigWorkspaceConfigReadModelType[keyof typeof ConfigWorkspaceConfigReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ConfigWorkspaceConfigReadModelType = {
  core: 'core',
  media: 'media',
  style: 'style',
  shop: 'shop',
  link: 'link',
} as const;

export interface ConfigWorkspaceConfigReadModel {
  /** Config ID */
  readonly id?: number;
  /**
   * Config type
   * @maxLength 20
   */
  type: ConfigWorkspaceConfigReadModelType;
  /**
   * Config key
   * @maxLength 30
   */
  key: string;
  /** If this config need to be used on public views (like auth page) */
  isPublic: boolean;
  /** If this config is secret (like API keys) */
  isSecret: boolean;
  /**
   * Config title
   * @maxLength 255
   */
  title: string;
  /**
   * Config description
   * @maxLength 255
   */
  description: string;
}

/**
 * The serialized payload of the violation
 */
export type ConstraintViolationModelViolationsItemPayload = { [key: string]: unknown };

export type ConstraintViolationModelViolationsItem = {
  /** The property path of the violation */
  propertyPath: string;
  /** The message associated with the violation */
  message: string;
  /** The code of the violation */
  code?: string;
  /** An extra hint to understand the violation */
  hint?: string;
  /** The serialized payload of the violation */
  payload?: ConstraintViolationModelViolationsItemPayload;
};

/**
 * Unprocessable entity
 */
export interface ConstraintViolationModel {
  status?: number;
  violations?: ConstraintViolationModelViolationsItem[];
  readonly detail?: string;
  readonly type?: string;
  /** @nullable */
  readonly title?: string | null;
  /** @nullable */
  readonly instance?: string | null;
}

/**
 * The serialized payload of the violation
 */
export type ConstraintViolationJsonldModelViolationsItemPayload = { [key: string]: unknown };

export type ConstraintViolationJsonldModelViolationsItem = {
  /** The property path of the violation */
  propertyPath: string;
  /** The message associated with the violation */
  message: string;
  /** The code of the violation */
  code?: string;
  /** An extra hint to understand the violation */
  hint?: string;
  /** The serialized payload of the violation */
  payload?: ConstraintViolationJsonldModelViolationsItemPayload;
};

/**
 * Unprocessable entity
 */
export interface ConstraintViolationJsonldModel {
  status?: number;
  violations?: ConstraintViolationJsonldModelViolationsItem[];
  readonly detail?: string;
  readonly description?: string;
  readonly type?: string;
  /** @nullable */
  readonly title?: string | null;
  /** @nullable */
  readonly instance?: string | null;
}

export interface CountryCompanyCollectionReadModel {
  /** Country name */
  name: string;
}

export interface CountryCompanyReadModel {
  /**
   * Country alpha3 code
   * @minLength 3
   * @maxLength 3
   */
  alpha3: string;
  /** Country name */
  name: string;
  /** Country currency */
  currencyName: string;
  /** Country currency symbol */
  currencySymbol: string;
}

export interface CountryCountryReadModel {
  /**
   * Country alpha3 code
   * @minLength 3
   * @maxLength 3
   */
  alpha3: string;
  /** Country alpha2 code */
  alpha2: string;
  /** Country name */
  name: string;
  /** Country currency */
  currencyName: string;
  /** Country currency symbol */
  currencySymbol: string;
}

export interface CountryCountryWriteModel {
  /**
   * Country alpha3 code
   * @minLength 3
   * @maxLength 3
   */
  alpha3: string;
}

export interface CountryMeReadModel {
  /**
   * Country alpha3 code
   * @minLength 3
   * @maxLength 3
   */
  alpha3: string;
  /** Country name */
  name: string;
  /** Country currency */
  currencyName: string;
  /** Country currency symbol */
  currencySymbol: string;
}

export interface CountryOrderReadModel {
  /** Country name */
  name: string;
}

export interface CountryWaitingListReadModel {
  /**
   * Country alpha3 code
   * @minLength 3
   * @maxLength 3
   */
  alpha3: string;
  /** Country name */
  name: string;
}

export interface DnsRecordWorkspaceConfigurationReadModel {
  /** What the record is used for */
  purpose: string;
  /** DNS record type */
  type: string;
  /** Record host, relative to the domain ("@" for the domain itself) */
  host: string;
  /** Expected record value */
  value: string;
  /** If the record is correctly set in the DNS zone */
  isValid: boolean;
}

export type EmailEmailReadModelUserWorkspace = UserWorkspaceEmailReadModel | null;

export interface EmailEmailReadModel {
  /** Email ID */
  readonly id: number;
  /** Email address of the user the email was sent to */
  to?: string;
  /**
   * Subject of the email at sending time
   * @nullable
   */
  subject?: string | null;
  userWorkspace?: EmailEmailReadModelUserWorkspace;
  /**
   * Date the email was sent
   * @nullable
   */
  sentAt?: string | null;
  /**
   * Last known status of the email (sent, opened, clicked, error)
   * @nullable
   */
  status?: string | null;
  /**
   * Date of the last status update
   * @nullable
   */
  statusUpdatedAt?: string | null;
}

/**
 * A representation of common errors.
 */
export interface ErrorModel {
  /**
   * A short, human-readable summary of the problem.
   * @nullable
   */
  readonly title?: string | null;
  /**
   * A human-readable explanation specific to this occurrence of the problem.
   * @nullable
   */
  readonly detail?: string | null;
  /** @nullable */
  status?: number | null;
  /**
   * A URI reference that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced.
   * @nullable
   */
  readonly instance?: string | null;
  /** A URI reference that identifies the problem type */
  readonly type?: string;
}

/**
 * A representation of common errors.
 */
export interface ErrorJsonldModel {
  /**
   * A short, human-readable summary of the problem.
   * @nullable
   */
  readonly title?: string | null;
  /**
   * A human-readable explanation specific to this occurrence of the problem.
   * @nullable
   */
  readonly detail?: string | null;
  /** @nullable */
  status?: number | null;
  /**
   * A URI reference that identifies the specific occurrence of the problem. It may or may not yield further information if dereferenced.
   * @nullable
   */
  readonly instance?: string | null;
  /** A URI reference that identifies the problem type */
  readonly type?: string;
  /** @nullable */
  readonly description?: string | null;
}

/**
 * Status of the game
 */
export type GameGameCollectionReadModelStatus = typeof GameGameCollectionReadModelStatus[keyof typeof GameGameCollectionReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GameGameCollectionReadModelStatus = {
  gamestatusplanned: 'game.status.planned',
  gamestatusactive: 'game.status.active',
  gamestatusfinished: 'game.status.finished',
  gamestatusforbidden: 'game.status.forbidden',
} as const;

export interface GameGameCollectionReadModel {
  /** Game ID */
  readonly id: number;
  /**
   * Game label
   * @maxLength 100
   */
  label: string;
  /**
   * Game description
   * @nullable
   */
  description?: string | null;
  /** Opening date of the game */
  openingDate: string;
  /** Closing date of the game */
  closingDate: string;
  /** Status of the game */
  status: GameGameCollectionReadModelStatus;
  cover: MediaGameCollectionReadModel;
  /** Game creation date */
  createdAt: string;
  createdBy?: UserWorkspaceGameCollectionReadModel;
  /** Number of segments attached to the game (only exposed to admins, on the collection) */
  segmentsCount?: number;
}

/**
 * Status of the game
 */
export type GameGameReadModelStatus = typeof GameGameReadModelStatus[keyof typeof GameGameReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GameGameReadModelStatus = {
  gamestatusplanned: 'game.status.planned',
  gamestatusactive: 'game.status.active',
  gamestatusfinished: 'game.status.finished',
  gamestatusforbidden: 'game.status.forbidden',
} as const;

export interface GameGameReadModel {
  /** Game ID */
  readonly id: number;
  /**
   * Game label
   * @maxLength 100
   */
  label: string;
  /**
   * Game description
   * @nullable
   */
  description?: string | null;
  /** Opening date of the game */
  openingDate: string;
  /** Closing date of the game */
  closingDate: string;
  /** Status of the game */
  status: GameGameReadModelStatus;
  /**
   * Link to the game
   * @maxLength 255
   */
  link: string;
  cover: MediaGameReadModel;
  /** Game creation date */
  createdAt: string;
  createdBy?: UserWorkspaceGameReadModel;
}

export interface GameGameUpdateJsonMergePatchModel {
  /**
   * Game label
   * @minLength 1
   * @maxLength 100
   */
  label?: string;
  /**
   * Game description
   * @nullable
   */
  description?: string | null;
  /** Opening date of the game */
  openingDate?: string;
  /** Closing date of the game */
  closingDate?: string;
  /**
   * Link to the game
   * @minLength 1
   * @maxLength 255
   */
  link?: string;
  /** Media associated with the game */
  cover?: string;
}

export interface GameGameWriteModel {
  /**
   * Game label
   * @maxLength 100
   */
  label: string;
  /**
   * Game description
   * @nullable
   */
  description?: string | null;
  /** Opening date of the game */
  openingDate: string;
  /** Closing date of the game */
  closingDate: string;
  /**
   * Link to the game
   * @maxLength 255
   */
  link: string;
  /** Media associated with the game */
  cover: string;
}

export interface ImportCompanyDtoModel {
  /** Payload data to import */
  data: string[];
  readonly targetClass?: string;
}

export interface ImportCompanyDtoCompanyImportModel {
  data: CompanyCompanyImportModel[];
}

export interface ImportLogicTypeTargetStatusDtoModel {
  data: string[];
  readonly targetClass?: string;
}

export interface ImportLogicTypeTargetStatusDtoTargetsImportModel {
  data: LogicTypeTargetStatusTargetsImportModel[];
}

export interface ImportPerformanceDtoModel {
  /** Payload data to import */
  data: string[];
  readonly targetClass?: string;
}

export interface ImportPerformanceDtoPerformanceImportModel {
  data: PerformancePerformanceImportModel[];
}

export interface ImportPointDtoModel {
  /** Payload data to import */
  data: string[];
  readonly targetClass?: string;
}

export interface ImportPointDtoPointImportModel {
  data: PointPointImportModel[];
}

export interface ImportReferenceDtoModel {
  data?: string[];
  readonly targetClass?: string;
}

export interface ImportReferenceDtoReferenceImportModel {
  data?: ReferenceReferenceImportModel[];
}

export interface ImportUserDtoModel {
  /** Payload data to import */
  data: string[];
  readonly targetClass?: string;
}

export interface ImportUserDtoUserImportModel {
  data: UserUserImportModel[];
}

export type InsightCompanyInsightCompanyReadModelCompaniesPerStepItem = {
  id: number;
  name: string;
  totalCompanies: number;
};

export interface InsightCompanyInsightCompanyReadModel {
  /** Total companies */
  totalCompanies: number;
  /** Total companies registered */
  totalCompaniesRegistered: number;
  /** Companies per step */
  companiesPerStep?: InsightCompanyInsightCompanyReadModelCompaniesPerStepItem[];
}

export type InsightCompanyInsightDashboardReadModelCompaniesPerTypologyItem = {
  typologyName: string;
  totalCompanies: number;
};

export interface InsightCompanyInsightDashboardReadModel {
  /** Total companies */
  totalCompanies: number;
  /** Total companies registered */
  totalCompaniesRegistered: number;
  /** Companies per typology */
  companiesPerTypology: InsightCompanyInsightDashboardReadModelCompaniesPerTypologyItem[];
  ranking: CompanyInsightDashboardReadModel[];
}

export interface InsightCompanyInsightPerformanceReadModel {
  ranking: CompanyInsightPerformanceReadModel[];
}

export interface InsightCompanyInsightPointReadModel {
  ranking: CompanyInsightPointReadModel[];
}

export interface InsightDashboardInsightDashboardReadModel {
  insightCompany: InsightCompanyInsightDashboardReadModel;
  insightPoint: InsightPointInsightDashboardReadModel;
}

export interface InsightOrderInsightOrderReadModel {
  /** Total amount of orders */
  totalOrders: number;
  /** Total points spent */
  totalSpentPoints: number;
  insightPoint: InsightPointInsightOrderReadModel;
  totalOrdersPerMonth: ValuePerMonthInsightOrderReadModel[];
  totalPointsSpentPerMonth: ValuePerMonthInsightOrderReadModel[];
}

export interface InsightPerformanceInsightPerformanceReadModel {
  /** Average amount by companies */
  avgAmountByCompanies: number;
  totalAmountPerMonth: ValuePerMonthInsightPerformanceReadModel[];
  insightCompany: InsightCompanyInsightPerformanceReadModel;
}

export type InsightPerformanceInsightUserMeReadModelTargetsAmountPerMonthItemTargetsItem = {
  targetId: number;
  targetReference: string;
  totalAmount: number;
};

export type InsightPerformanceInsightUserMeReadModelTargetsAmountPerMonthItem = {
  month: number;
  year: number;
  targets: InsightPerformanceInsightUserMeReadModelTargetsAmountPerMonthItemTargetsItem[];
};

export interface InsightPerformanceInsightUserMeReadModel {
  /** Total amount for each targets per month */
  targetsAmountPerMonth?: InsightPerformanceInsightUserMeReadModelTargetsAmountPerMonthItem[];
  performancesTargetHistory?: PerformanceInsightUserMeReadModel[];
}

export interface InsightPointInsightDashboardReadModel {
  /** Total acquired points */
  totalAcquiredPoints: number;
  /** Total acquired points by registered companies */
  totalAcquiredPointsRegisteredCompanies: number;
  /** Total spent points */
  totalSpentPoints: number;
  /** Total balance (spendable points) of the companies */
  totalBalance: number;
}

export interface InsightPointInsightOrderReadModel {
  /** Total acquired points */
  totalAcquiredPoints: number;
}

export interface InsightPointInsightPointReadModel {
  /** Average acquired points */
  avgAcquiredPoints: number;
  totalPointsPerMonth: ValuePerMonthInsightPointReadModel[];
  insightCompany: InsightCompanyInsightPointReadModel;
}

export interface InsightPointInsightUserMeReadModel {
  totalPointsPerMonth: ValuePerMonthInsightUserMeReadModel[];
  pointsHistory: PointInsightUserMeReadModel[];
}

export interface InsightUserInsightUserReadModel {
  /** Total users */
  totalUsers: number;
  /** Total users registered */
  totalUsersRegistered: number;
  /** Total logins on the workspace for the current year */
  totalLogins: number;
}

export interface InsightUserInsightUserMeReadModel {
  insightPoints: InsightPointInsightUserMeReadModel;
  insightPerformance?: InsightPerformanceInsightUserMeReadModel;
}

export interface LocaleModel {
  /** Locale ID */
  readonly id?: number;
  /**
   * Label of the locale
   * @pattern ^([a-z0-9._-]+)$
   */
  label: string;
  /** Text of the locale */
  content: string;
  /** ISO code of the locale */
  isoCode: string;
  /** Country IRI */
  country: string;
  isPublic: boolean;
  /** Is locale overrided by active workspace */
  isCustom?: boolean;
  localeCustoms?: string[];
  /**
   * Default content
   * @nullable
   */
  defaultContent?: string | null;
  /** Is locale can be edited */
  isEditable: boolean;
}

export interface LocaleLocaleAdminReadModel {
  /** Locale ID */
  readonly id?: number;
  /**
   * Label of the locale
   * @pattern ^([a-z0-9._-]+)$
   */
  label: string;
  /** Text of the locale */
  content: string;
  /** ISO code of the locale */
  isoCode: string;
  isPublic: boolean;
  /** Is locale overrided by active workspace */
  isCustom?: boolean;
  /**
   * Default content
   * @nullable
   */
  defaultContent?: string | null;
  /** Is locale can be edited */
  isEditable: boolean;
}

export interface LocaleLocaleWriteModel {
  /**
   * Label of the locale
   * @pattern ^([a-z0-9._-]+)$
   */
  label: string;
  /** Text of the locale */
  content: string;
  /** Country IRI */
  country: string;
  isPublic: boolean;
  /** Is locale can be edited */
  isEditable: boolean;
}

export interface LocaleLocaleWriteJsonMergePatchModel {
  /**
   * Label of the locale
   * @pattern ^([a-z0-9._-]+)$
   */
  label?: string;
  /** Text of the locale */
  content?: string;
  /** Country IRI */
  country?: string;
  isPublic?: boolean;
  /** Is locale can be edited */
  isEditable?: boolean;
}

export interface LocaleGroupedLocaleModel {
  groupedLocales?: (string | null)[];
}

export interface LocaleCustomModel {
  /** Locale Custom ID */
  readonly id?: number;
  /** Locale IRI */
  locale: string;
  /** Workspace IRI */
  workspace: string;
  /** Text of the locale overrided */
  content: string;
}

export interface LocaleCustomLocaleCustomEditJsonMergePatchModel {
  /** Text of the locale overrided */
  content?: string;
}

export interface LocaleCustomLocaleCustomWriteModel {
  /** Locale IRI */
  locale: string;
  /** Text of the locale overrided */
  content: string;
}

/**
 * @maxLength 20
 */
export type LogicLogicReadModelType = typeof LogicLogicReadModelType[keyof typeof LogicLogicReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogicLogicReadModelType = {
  STEP: 'STEP',
  LINEAR: 'LINEAR',
  TARGET_PERF: 'TARGET_PERF',
  TARGET_POINT: 'TARGET_POINT',
} as const;

export interface LogicLogicReadModel {
  /** Logic ID */
  readonly id: number;
  /**
   * Name (label) of the logic
   * @maxLength 100
   */
  name: string;
  /**
   * Description (label) of the logic
   * @maxLength 100
   */
  description: string;
  /** @maxLength 20 */
  type: LogicLogicReadModelType;
}

/**
 * @maxLength 20
 */
export type LogicLogicWriteModelType = typeof LogicLogicWriteModelType[keyof typeof LogicLogicWriteModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogicLogicWriteModelType = {
  STEP: 'STEP',
  LINEAR: 'LINEAR',
  TARGET_PERF: 'TARGET_PERF',
  TARGET_POINT: 'TARGET_POINT',
} as const;

export interface LogicLogicWriteModel {
  /**
   * Name (label) of the logic
   * @maxLength 100
   */
  name: string;
  /**
   * Description (label) of the logic
   * @maxLength 100
   */
  description: string;
  /** @maxLength 20 */
  type: LogicLogicWriteModelType;
}

/**
 * @maxLength 20
 */
export type LogicLogicWorkspaceReadModelType = typeof LogicLogicWorkspaceReadModelType[keyof typeof LogicLogicWorkspaceReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogicLogicWorkspaceReadModelType = {
  STEP: 'STEP',
  LINEAR: 'LINEAR',
  TARGET_PERF: 'TARGET_PERF',
  TARGET_POINT: 'TARGET_POINT',
} as const;

export interface LogicLogicWorkspaceReadModel {
  /** Logic ID */
  readonly id: number;
  /**
   * Name (label) of the logic
   * @maxLength 100
   */
  name: string;
  /**
   * Description (label) of the logic
   * @maxLength 100
   */
  description: string;
  /** @maxLength 20 */
  type: LogicLogicWorkspaceReadModelType;
}

/**
 * @maxLength 20
 */
export type LogicWorkspaceReadModelType = typeof LogicWorkspaceReadModelType[keyof typeof LogicWorkspaceReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogicWorkspaceReadModelType = {
  STEP: 'STEP',
  LINEAR: 'LINEAR',
  TARGET_PERF: 'TARGET_PERF',
  TARGET_POINT: 'TARGET_POINT',
} as const;

export interface LogicWorkspaceReadModel {
  /**
   * Name (label) of the logic
   * @maxLength 100
   */
  name: string;
  /**
   * Description (label) of the logic
   * @maxLength 100
   */
  description: string;
  /** @maxLength 20 */
  type: LogicWorkspaceReadModelType;
}

/**
 * @maxLength 20
 */
export type LogicWorkspaceReadAdminWorkspaceReadModelType = typeof LogicWorkspaceReadAdminWorkspaceReadModelType[keyof typeof LogicWorkspaceReadAdminWorkspaceReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const LogicWorkspaceReadAdminWorkspaceReadModelType = {
  STEP: 'STEP',
  LINEAR: 'LINEAR',
  TARGET_PERF: 'TARGET_PERF',
  TARGET_POINT: 'TARGET_POINT',
} as const;

export interface LogicWorkspaceReadAdminWorkspaceReadModel {
  /**
   * Name (label) of the logic
   * @maxLength 100
   */
  name: string;
  /**
   * Description (label) of the logic
   * @maxLength 100
   */
  description: string;
  /** @maxLength 20 */
  type: LogicWorkspaceReadAdminWorkspaceReadModelType;
}

export interface LogicTypeStepCompanyCollectionReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
}

export interface LogicTypeStepCompanyReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
}

export interface LogicTypeStepGroupedRewardReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
}

export interface LogicTypeStepLogicTypeStepHistoryCollectionReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
  /**
   * Step description
   * @nullable
   */
  description?: string | null;
  /**
   * Value to complete the step
   * @minimum 0
   * @exclusiveMinimum
   */
  stepPoint: number;
}

export interface LogicTypeStepLogicTypeStepPatchJsonMergePatchModel {
  /**
   * Step name
   * @maxLength 50
   */
  name?: string;
  /**
   * Step description
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeStepLogicTypeStepReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
  /**
   * Step description
   * @nullable
   */
  description?: string | null;
  /**
   * Value to complete the step
   * @minimum 0
   * @exclusiveMinimum
   */
  stepPoint: number;
  /** Step creation datetime */
  createdAt?: string;
}

export interface LogicTypeStepLogicWorkspaceReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
  /**
   * Value to complete the step
   * @minimum 0
   * @exclusiveMinimum
   */
  stepPoint: number;
}

export interface LogicTypeStepLogicWorkspaceWriteJsonMergePatchModel {
  /**
   * Step name
   * @maxLength 50
   */
  name?: string;
  /**
   * Step description
   * @nullable
   */
  description?: string | null;
  /**
   * Value to complete the step
   * @minimum 0
   * @exclusiveMinimum
   */
  stepPoint?: number;
}

export interface LogicTypeStepMeReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
}

export interface LogicTypeStepRewardReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
}

export interface LogicTypeStepUserReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
}

export interface LogicTypeStepWorkspaceReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
  /**
   * Step description
   * @nullable
   */
  description?: string | null;
  /**
   * Value to complete the step
   * @minimum 0
   * @exclusiveMinimum
   */
  stepPoint: number;
}

export interface LogicTypeStepWorkspaceReadAdminWorkspaceReadModel {
  /** Step ID */
  readonly id?: number;
  /**
   * Step name
   * @maxLength 50
   */
  name: string;
  /**
   * Step description
   * @nullable
   */
  description?: string | null;
  /**
   * Value to complete the step
   * @minimum 0
   * @exclusiveMinimum
   */
  stepPoint: number;
}

export interface LogicTypeStepWorkspaceWriteJsonMergePatchModel {
  /**
   * Step name
   * @maxLength 50
   */
  name?: string;
  /**
   * Step description
   * @nullable
   */
  description?: string | null;
  /**
   * Value to complete the step
   * @minimum 0
   * @exclusiveMinimum
   */
  stepPoint?: number;
}

export interface LogicTypeStepHistoryCompanyCollectionReadModel {
  logicTypeStep: LogicTypeStepCompanyCollectionReadModel;
  /** Step history creation datetime */
  createdAt: string;
}

export interface LogicTypeStepHistoryCompanyReadModel {
  logicTypeStep: LogicTypeStepCompanyReadModel;
  /** Step history creation datetime */
  createdAt: string;
}

export interface LogicTypeStepHistoryLogicTypeStepHistoryCollectionReadModel {
  /** Step History ID */
  readonly id?: number;
  logicTypeStep: LogicTypeStepLogicTypeStepHistoryCollectionReadModel;
  /** Step history creation datetime */
  createdAt: string;
  company?: CompanyLogicTypeStepHistoryCollectionReadModel;
}

export interface LogicTypeStepHistoryMeReadModel {
  logicTypeStep: LogicTypeStepMeReadModel;
  /** Step history creation datetime */
  createdAt: string;
}

export interface LogicTypeStepHistoryUserReadModel {
  logicTypeStep: LogicTypeStepUserReadModel;
  /** Step history creation datetime */
  createdAt: string;
}

export interface LogicTypeTargetCompanyReadModel {
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
  /**
   * Target description (label)
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeTargetInsightUserMeReadModel {
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
}

export interface LogicTypeTargetLogicTypeTargetStatusCollectionReadModel {
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
  /**
   * Target description (label)
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeTargetLogicWorkspaceReadModel {
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
  /**
   * Target description (label)
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeTargetLogicWorkspaceWriteModel {
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
  /**
   * Target description (label)
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeTargetMeReadModel {
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
  /**
   * Target description (label)
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeTargetPerformanceCollectionReadModel {
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
}

export interface LogicTypeTargetWorkspaceReadModel {
  /** Target ID */
  readonly id?: number;
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
  /**
   * Target description (label)
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeTargetWorkspaceReadAdminWorkspaceReadModel {
  /** Target ID */
  readonly id?: number;
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
  /**
   * Target description (label)
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeTargetWorkspaceWriteModel {
  /**
   * Target reference name
   * @maxLength 20
   */
  reference: string;
  /**
   * Target description (label)
   * @nullable
   */
  description?: string | null;
}

export interface LogicTypeTargetStatusCompanyReadModel {
  /** Target Status ID */
  readonly id: number;
  logicTypeTarget?: LogicTypeTargetCompanyReadModel;
  /**
   * Current target value (in points or euros)
   * @minimum 0
   */
  value: number;
  /**
   * Target value to achieve (in points or euros)
   * @minimum 0
   * @exclusiveMinimum
   */
  targetValue: number;
  /** Date of the last update */
  updatedAt?: string;
  /**
   * Date when the target was achieved
   * @nullable
   */
  achievedAt?: string | null;
  readonly achievedPercentage?: number;
}

export interface LogicTypeTargetStatusLogicTypeTargetStatusCollectionReadModel {
  /** Target Status ID */
  readonly id: number;
  company: CompanyLogicTypeTargetStatusCollectionReadModel;
  logicTypeTarget?: LogicTypeTargetLogicTypeTargetStatusCollectionReadModel;
  /**
   * Current target value (in points or euros)
   * @minimum 0
   */
  value: number;
  /**
   * Target value to achieve (in points or euros)
   * @minimum 0
   * @exclusiveMinimum
   */
  targetValue: number;
  /** Date of the last update */
  updatedAt?: string;
  /**
   * Date when the target was achieved
   * @nullable
   */
  achievedAt?: string | null;
  readonly achievedPercentage?: number;
}

export interface LogicTypeTargetStatusMeReadModel {
  /** Target Status ID */
  readonly id: number;
  logicTypeTarget?: LogicTypeTargetMeReadModel;
  /**
   * Current target value (in points or euros)
   * @minimum 0
   */
  value: number;
  /**
   * Target value to achieve (in points or euros)
   * @minimum 0
   * @exclusiveMinimum
   */
  targetValue: number;
  /** Date of the last update */
  updatedAt?: string;
  /**
   * Date when the target was achieved
   * @nullable
   */
  achievedAt?: string | null;
  readonly achievedPercentage?: number;
}

export interface LogicTypeTargetStatusTargetsImportModel {
  /**
   * Company unique code
   * @nullable
   */
  companyUniqueCode: string | null;
  /**
   * Target reference name
   * @nullable
   */
  targetReference: string | null;
  /**
   * Target value to achieve (in points or euros)
   * @minimum 0
   * @exclusiveMinimum
   */
  targetValue: number;
}

export interface LogicWorkspaceLogicWorkspaceReadModel {
  /** Logic Workspace ID */
  readonly id: number;
  logic: LogicLogicWorkspaceReadModel;
  /** Start datetime of the logic workspace */
  startAt: string;
  /** End datetime of the logic workspace */
  endAt: string;
  steps?: LogicTypeStepLogicWorkspaceReadModel[];
  targets?: LogicTypeTargetLogicWorkspaceReadModel[];
  /**
   * Point expiration date of the logic workspace
   * @maxLength 100
   */
  pointExpirationDate: string;
}

export interface LogicWorkspaceLogicWorkspaceWriteModel {
  /** Logic ID */
  logic: string;
  /** Start datetime of the logic workspace */
  startAt: string;
  /** End datetime of the logic workspace */
  endAt: string;
  steps?: LogicTypeStepLogicWorkspaceWriteJsonMergePatchModel[];
  targets?: LogicTypeTargetLogicWorkspaceWriteModel[];
  /**
   * Point expiration date of the logic workspace
   * @maxLength 100
   */
  pointExpirationDate: string;
}

export interface LogicWorkspaceWorkspaceReadModel {
  /** Logic Workspace ID */
  readonly id: number;
  logic: LogicWorkspaceReadModel;
  /** Start datetime of the logic workspace */
  startAt: string;
  /** End datetime of the logic workspace */
  endAt: string;
  steps?: LogicTypeStepWorkspaceReadModel[];
  targets?: LogicTypeTargetWorkspaceReadModel[];
  /**
   * Point expiration date of the logic workspace
   * @maxLength 100
   */
  pointExpirationDate: string;
}

export interface LogicWorkspaceWorkspaceReadAdminWorkspaceReadModel {
  /** Logic Workspace ID */
  readonly id: number;
  logic: LogicWorkspaceReadAdminWorkspaceReadModel;
  /** Start datetime of the logic workspace */
  startAt: string;
  /** End datetime of the logic workspace */
  endAt: string;
  steps?: LogicTypeStepWorkspaceReadAdminWorkspaceReadModel[];
  targets?: LogicTypeTargetWorkspaceReadAdminWorkspaceReadModel[];
  /**
   * Point expiration date of the logic workspace
   * @maxLength 100
   */
  pointExpirationDate: string;
}

export interface LogicWorkspaceWorkspaceWriteModel {
  /** Logic ID */
  logic: string;
  /** Start datetime of the logic workspace */
  startAt: string;
  /** End datetime of the logic workspace */
  endAt: string;
  steps?: LogicTypeStepWorkspaceWriteJsonMergePatchModel[];
  targets?: LogicTypeTargetWorkspaceWriteModel[];
  /**
   * Point expiration date of the logic workspace
   * @maxLength 100
   */
  pointExpirationDate: string;
}

export interface MediaChangelogReadModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaGameCollectionReadModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaGameReadModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaMediaReadModel {
  /** Media ID */
  readonly id: number;
  /** Media IRI */
  iri: string;
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaOrderCollectionReadModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaOrderReadModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaProductReadModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaProductReadProductReadSensitiveModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaPurchaseProofReadModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

export interface MediaShopReadModel {
  /**
   * Media path to S3
   * @nullable
   */
  pathUri: string | null;
}

/**
 * Order status (label)
 * @maxLength 50
 */
export type OrderCompanyReadModelStatus = typeof OrderCompanyReadModelStatus[keyof typeof OrderCompanyReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderCompanyReadModelStatus = {
  orderstatuspending: 'order.status.pending',
  orderstatusconfirmed: 'order.status.confirmed',
  orderstatuscompleted: 'order.status.completed',
  orderstatuscanceled: 'order.status.canceled',
  orderstatusfailed: 'order.status.failed',
} as const;

/**
 * Order type
 * @maxLength 10
 */
export type OrderCompanyReadModelType = typeof OrderCompanyReadModelType[keyof typeof OrderCompanyReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderCompanyReadModelType = {
  provider: 'provider',
  reward: 'reward',
  custom: 'custom',
} as const;

export type OrderCompanyReadModelPoint = PointCompanyReadModel | null;

export interface OrderCompanyReadModel {
  /** Order ID */
  readonly id: number;
  /**
   * Order reference
   * @maxLength 20
   */
  reference: string;
  /**
   * Order status (label)
   * @maxLength 50
   */
  status: OrderCompanyReadModelStatus;
  /**
   * Order type
   * @maxLength 10
   */
  type: OrderCompanyReadModelType;
  point?: OrderCompanyReadModelPoint;
  madeBy: UserWorkspaceCompanyReadModel;
  /** Order creation date */
  createdAt: string;
  /** Number of products in the order */
  productsCount: number;
  readonly shops: readonly ShopCompanyReadModel[];
}

/**
 * Order status (label)
 * @maxLength 50
 */
export type OrderOrderCollectionReadModelStatus = typeof OrderOrderCollectionReadModelStatus[keyof typeof OrderOrderCollectionReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderOrderCollectionReadModelStatus = {
  orderstatuspending: 'order.status.pending',
  orderstatusconfirmed: 'order.status.confirmed',
  orderstatuscompleted: 'order.status.completed',
  orderstatuscanceled: 'order.status.canceled',
  orderstatusfailed: 'order.status.failed',
} as const;

/**
 * Order type
 * @maxLength 10
 */
export type OrderOrderCollectionReadModelType = typeof OrderOrderCollectionReadModelType[keyof typeof OrderOrderCollectionReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderOrderCollectionReadModelType = {
  provider: 'provider',
  reward: 'reward',
  custom: 'custom',
} as const;

export type OrderOrderCollectionReadModelPoint = PointOrderCollectionReadModel | null;

export interface OrderOrderCollectionReadModel {
  /** Order ID */
  readonly id: number;
  /**
   * Order reference
   * @maxLength 20
   */
  reference: string;
  /**
   * Order status (label)
   * @maxLength 50
   */
  status: OrderOrderCollectionReadModelStatus;
  /**
   * Order type
   * @maxLength 10
   */
  type: OrderOrderCollectionReadModelType;
  point?: OrderOrderCollectionReadModelPoint;
  madeBy: UserWorkspaceOrderCollectionReadModel;
  company: CompanyOrderCollectionReadModel;
  /** Order creation date */
  createdAt: string;
  orderProducts: OrderProductOrderCollectionReadModel[];
  /** Number of products in the order */
  productsCount: number;
  readonly shops: readonly ShopOrderCollectionReadModel[];
}

/**
 * Order status (label)
 * @maxLength 50
 */
export type OrderOrderReadModelStatus = typeof OrderOrderReadModelStatus[keyof typeof OrderOrderReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderOrderReadModelStatus = {
  orderstatuspending: 'order.status.pending',
  orderstatusconfirmed: 'order.status.confirmed',
  orderstatuscompleted: 'order.status.completed',
  orderstatuscanceled: 'order.status.canceled',
  orderstatusfailed: 'order.status.failed',
} as const;

/**
 * Order type
 * @maxLength 10
 */
export type OrderOrderReadModelType = typeof OrderOrderReadModelType[keyof typeof OrderOrderReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderOrderReadModelType = {
  provider: 'provider',
  reward: 'reward',
  custom: 'custom',
} as const;

export type OrderOrderReadModelPoint = PointOrderReadModel | null;

export interface OrderOrderReadModel {
  /** Order ID */
  readonly id: number;
  /**
   * Order reference
   * @maxLength 20
   */
  reference: string;
  /**
   * Order status (label)
   * @maxLength 50
   */
  status: OrderOrderReadModelStatus;
  /**
   * Order type
   * @maxLength 10
   */
  type: OrderOrderReadModelType;
  point?: OrderOrderReadModelPoint;
  madeBy: UserWorkspaceOrderReadModel;
  company: CompanyOrderReadModel;
  /** Order creation date */
  createdAt: string;
  orderProducts: OrderProductOrderReadModel[];
  /** Number of products in the order */
  productsCount: number;
  readonly shops: readonly ShopOrderReadModel[];
  /** Tracking link */
  trackingLink?: (string | null)[];
}

export interface OrderOrderWriteModel {
  orderProducts: OrderProductOrderWriteModel[];
}

export interface OrderProductOrderCollectionReadModel {
  product: ProductOrderCollectionReadModel;
  /**
   * Point unit price
   * @minimum 0
   */
  pointUnitPrice: number;
  /**
   * Quantity
   * @minimum 0
   * @exclusiveMinimum
   */
  quantity: number;
  /**
   * Dynamic price (euros). Used for pointUnitPrice calculation
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  dynamicPriceAmount?: number | null;
  /**
   * Total price (euros) for one quantity
   * @minimum 0
   */
  amountUnitPrice: number;
}

export type OrderProductOrderReadModelOrderProductCode = OrderProductCodeOrderReadModel | null;

export interface OrderProductOrderReadModel {
  product: ProductOrderReadModel;
  /**
   * Point unit price
   * @minimum 0
   */
  pointUnitPrice: number;
  /**
   * Quantity
   * @minimum 0
   * @exclusiveMinimum
   */
  quantity: number;
  /**
   * Total price (euros) for one quantity
   * @minimum 0
   */
  amountUnitPrice: number;
  orderProductCode?: OrderProductOrderReadModelOrderProductCode;
}

export interface OrderProductOrderWriteModel {
  /** Product shipped */
  product: string;
  /**
   * Quantity
   * @minimum 0
   * @exclusiveMinimum
   */
  quantity: number;
  /**
   * Dynamic price (euros). Used for pointUnitPrice calculation
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  dynamicPriceAmount?: number | null;
}

export interface OrderProductCodeOrderReadModel {
  code: string;
  /** @nullable */
  expiredAt?: string | null;
}

export type PerformanceInsightUserMeReadModelLogicTypeTarget = LogicTypeTargetInsightUserMeReadModel | null;

export interface PerformanceInsightUserMeReadModel {
  /**
   * Amount (in euros)
   * @minimum 0
   */
  amount?: number;
  /**
   * Performance label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  /** Performance realisation date */
  realizedAt: string;
  logicTypeTarget?: PerformanceInsightUserMeReadModelLogicTypeTarget;
  /**
   * Reference unique code
   * @nullable
   */
  referenceUniqueCode?: string | null;
  /**
   * Reference quantity buyed
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  referenceQuantity?: number | null;
}

export type PerformancePerformanceCollectionReadModelRealizedBy = UserWorkspacePerformanceCollectionReadModel | null;

export type PerformancePerformanceCollectionReadModelPoint = PointPerformanceCollectionReadModel | null;

export type PerformancePerformanceCollectionReadModelLogicTypeTarget = LogicTypeTargetPerformanceCollectionReadModel | null;

export type PerformancePerformanceCollectionReadModelAddedByUserWorkspace = UserWorkspacePerformanceCollectionReadModel | null;

export interface PerformancePerformanceCollectionReadModel {
  /** Performance ID */
  readonly id: number;
  /**
   * Amount (in euros)
   * @minimum 0
   */
  amount?: number;
  /**
   * Performance label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  /** Performance realisation date */
  realizedAt: string;
  /** Points creation date */
  createdAt: string;
  realizedBy: PerformancePerformanceCollectionReadModelRealizedBy;
  point?: PerformancePerformanceCollectionReadModelPoint;
  realizedByCompany: CompanyPerformanceCollectionReadModel;
  logicTypeTarget?: PerformancePerformanceCollectionReadModelLogicTypeTarget;
  addedByUserWorkspace?: PerformancePerformanceCollectionReadModelAddedByUserWorkspace;
  /**
   * Reference unique code
   * @nullable
   */
  referenceUniqueCode?: string | null;
  /**
   * Purchase proof linked to this performance
   * @nullable
   */
  purchaseProof?: string | null;
  /**
   * Reference quantity buyed
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  referenceQuantity?: number | null;
}

export interface PerformancePerformanceImportModel {
  /**
   * Amount (in euros)
   * @minimum 0
   */
  amount?: number;
  /**
   * Performance label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  /** Performance realisation date */
  realizedAt: string;
  /**
   * User unique code who realized the performance
   * @nullable
   */
  userUniqueCode?: string | null;
  /**
   * Company unique code who realized the performance
   * @nullable
   */
  companyUniqueCode: string | null;
  /**
   * Target reference
   * @nullable
   */
  targetReference?: string | null;
  /**
   * Reference unique code
   * @nullable
   */
  referenceUniqueCode?: string | null;
  /**
   * Purchase proof linked to this performance
   * @nullable
   */
  purchaseProof?: string | null;
  /**
   * Reference quantity buyed
   * @minimum 0
   * @exclusiveMinimum
   * @nullable
   */
  referenceQuantity?: number | null;
}

export type PerformancePerformanceReadModelPoint = PointPerformanceReadModel | null;

export type PerformancePerformanceReadModelAddedByUserWorkspace = UserWorkspacePerformanceReadModel | null;

export interface PerformancePerformanceReadModel {
  /** Performance ID */
  readonly id: number;
  /**
   * Amount (in euros)
   * @minimum 0
   */
  amount?: number;
  /**
   * Performance label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  /** Performance realisation date */
  realizedAt: string;
  /** Points creation date */
  createdAt: string;
  point?: PerformancePerformanceReadModelPoint;
  realizedByCompany: CompanyPerformanceReadModel;
  addedByUserWorkspace?: PerformancePerformanceReadModelAddedByUserWorkspace;
  /**
   * Purchase proof linked to this performance
   * @nullable
   */
  purchaseProof?: string | null;
}

export interface PerformancePurchaseProofReadModel {
  /** Performance ID */
  readonly id: number;
  /**
   * Amount (in euros)
   * @minimum 0
   */
  amount?: number;
  /**
   * Performance label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  /** Performance realisation date */
  realizedAt: string;
}

export type PointCompanyReadModelAddedByUserWorkspace = UserWorkspaceCompanyReadModel | null;

export interface PointCompanyReadModel {
  /** Points amount */
  amount: number;
  /**
   * Points label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  addedByUserWorkspace?: PointCompanyReadModelAddedByUserWorkspace;
  /** Points value date */
  valueDate: string;
}

export type PointMeReadModelTypeLabel = typeof PointMeReadModelTypeLabel[keyof typeof PointMeReadModelTypeLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointMeReadModelTypeLabel = {
  CORE: 'CORE',
  IMPORTED: 'IMPORTED',
  SPENT: 'SPENT',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  BOOSTER: 'BOOSTER',
} as const;

export interface PointMeReadModel {
  /** Points amount */
  amount: number;
  /**
   * Points label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  typeLabel: PointMeReadModelTypeLabel;
  /**
   * Points expiration date
   * @nullable
   */
  expirationDate?: string | null;
  /** Points creation date */
  createdAt: string;
  /** Points value date */
  valueDate: string;
}

export interface PointOrderCollectionReadModel {
  /** Points amount */
  amount: number;
}

export interface PointOrderReadModel {
  /** Points amount */
  amount: number;
}

export interface PointPerformanceCollectionReadModel {
  /** Points amount */
  amount: number;
}

export interface PointPerformanceReadModel {
  /** Points amount */
  amount: number;
}

export type PointPointCollectionReadModelObtainedBy = UserWorkspacePointCollectionReadModel | null;

export type PointPointCollectionReadModelTypeLabel = typeof PointPointCollectionReadModelTypeLabel[keyof typeof PointPointCollectionReadModelTypeLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointPointCollectionReadModelTypeLabel = {
  CORE: 'CORE',
  IMPORTED: 'IMPORTED',
  SPENT: 'SPENT',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  BOOSTER: 'BOOSTER',
} as const;

export type PointPointCollectionReadModelAddedByUserWorkspace = UserWorkspacePointCollectionReadModel | null;

export type PointPointCollectionReadModelBooster = BoosterPointCollectionReadModel | null;

export interface PointPointCollectionReadModel {
  /** Points ID */
  readonly id: number;
  obtainedBy?: PointPointCollectionReadModelObtainedBy;
  attributedToCompany: CompanyPointCollectionReadModel;
  /** Points amount */
  amount: number;
  /**
   * Points label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  typeLabel: PointPointCollectionReadModelTypeLabel;
  /**
   * Points expiration date
   * @nullable
   */
  expirationDate?: string | null;
  /** Points creation date */
  createdAt: string;
  addedByUserWorkspace?: PointPointCollectionReadModelAddedByUserWorkspace;
  /** Points value date */
  valueDate: string;
  /**
   * Logic target linked to the points
   * @nullable
   */
  logicTypeTarget?: string | null;
  booster?: PointPointCollectionReadModelBooster;
}

export type PointPointImportModelTypeLabel = typeof PointPointImportModelTypeLabel[keyof typeof PointPointImportModelTypeLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointPointImportModelTypeLabel = {
  CORE: 'CORE',
  IMPORTED: 'IMPORTED',
  SPENT: 'SPENT',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  BOOSTER: 'BOOSTER',
} as const;

export interface PointPointImportModel {
  /**
   * User unique code
   * @nullable
   */
  userUniqueCode?: string | null;
  /**
   * Company unique code
   * @nullable
   */
  companyUniqueCode: string | null;
  /** Points amount */
  amount: number;
  /**
   * Points label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  typeLabel: PointPointImportModelTypeLabel;
  /**
   * Points expiration date
   * @nullable
   */
  expirationDate?: string | null;
  /** Points value date */
  valueDate: string;
  /**
   * Target reference
   * @nullable
   */
  targetReference?: string | null;
}

export type PointPointReadModelObtainedBy = UserWorkspacePointReadModel | null;

export type PointPointReadModelTypeLabel = typeof PointPointReadModelTypeLabel[keyof typeof PointPointReadModelTypeLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointPointReadModelTypeLabel = {
  CORE: 'CORE',
  IMPORTED: 'IMPORTED',
  SPENT: 'SPENT',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  BOOSTER: 'BOOSTER',
} as const;

export type PointPointReadModelAddedByUserWorkspace = UserWorkspacePointReadModel | null;

export type PointPointReadModelBooster = BoosterPointReadModel | null;

export interface PointPointReadModel {
  /** Points ID */
  readonly id: number;
  obtainedBy?: PointPointReadModelObtainedBy;
  attributedToCompany: CompanyPointReadModel;
  /** Points amount */
  amount: number;
  /**
   * Points label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  typeLabel: PointPointReadModelTypeLabel;
  /**
   * Points expiration date
   * @nullable
   */
  expirationDate?: string | null;
  /** Points creation date */
  createdAt: string;
  addedByUserWorkspace?: PointPointReadModelAddedByUserWorkspace;
  /** Points value date */
  valueDate: string;
  /**
   * Logic target linked to the points
   * @nullable
   */
  logicTypeTarget?: string | null;
  booster?: PointPointReadModelBooster;
}

export type PointUserReadModelTypeLabel = typeof PointUserReadModelTypeLabel[keyof typeof PointUserReadModelTypeLabel];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PointUserReadModelTypeLabel = {
  CORE: 'CORE',
  IMPORTED: 'IMPORTED',
  SPENT: 'SPENT',
  EXPIRED: 'EXPIRED',
  CANCELED: 'CANCELED',
  BOOSTER: 'BOOSTER',
} as const;

export interface PointUserReadModel {
  /** Points amount */
  amount: number;
  /**
   * Points label
   * @maxLength 255
   * @nullable
   */
  label?: string | null;
  typeLabel: PointUserReadModelTypeLabel;
  /**
   * Points expiration date
   * @nullable
   */
  expirationDate?: string | null;
  /** Points creation date */
  createdAt: string;
  /** Points value date */
  valueDate: string;
}

export interface ProductGroupedRewardReadModel {
  /** Product ID */
  readonly id: number;
  /**
   * Product name
   * @maxLength 150
   */
  name: string;
  /**
   * Product description
   * @nullable
   */
  description?: string | null;
}

export interface ProductOrderCollectionReadModel {
  /** Product ID */
  readonly id: number;
  /**
   * Product name
   * @maxLength 150
   */
  name: string;
  isDemat: boolean;
}

export interface ProductOrderReadModel {
  /** Product ID */
  readonly id: number;
  /**
   * Product name
   * @maxLength 150
   */
  name: string;
  /**
   * Product description
   * @nullable
   */
  description?: string | null;
  /** Product dynamic price */
  dynamicPrice: boolean;
  images?: MediaOrderReadModel[];
  /**
   * @maxLength 255
   * @nullable
   */
  designationCom?: string | null;
  /**
   * @maxLength 20
   * @nullable
   */
  ean?: string | null;
  isDemat: boolean;
  readonly publicMetadatas?: readonly ProductMetadataOrderReadModel[];
}

export type ProductProductReadModelCategory = ProductCategoryProductReadModel | null;

export type ProductProductReadModelBrand = ProductBrandProductReadModel | null;

export interface ProductProductReadModel {
  /** Product ID */
  readonly id: number;
  /**
   * Product name
   * @maxLength 150
   */
  name: string;
  /**
   * Product description
   * @nullable
   */
  description?: string | null;
  /**
   * Product price
   * @minimum 0
   * @nullable
   */
  price?: number | null;
  /** Product point unit */
  pointUnitPrice: number;
  /**
   * Product dynamic quantity
   * @nullable
   */
  readonly dynamicQuantity: number | null;
  /** Product dynamic price */
  dynamicPrice: boolean;
  /** Date and time when the product was created */
  createdAt: string;
  images?: MediaProductReadModel[];
  /**
   * @maxLength 255
   * @nullable
   */
  designationCom?: string | null;
  /**
   * @maxLength 20
   * @nullable
   */
  ean?: string | null;
  /** Product archived status */
  isArchived: boolean;
  isDemat: boolean;
  /**
   * Product TVA
   * @minimum 0
   */
  tva: number;
  /**
   * Product shipping price
   * @minimum 0
   */
  shippingPrice: number;
  category?: ProductProductReadModelCategory;
  brand?: ProductProductReadModelBrand;
  /**
   * Product stock
   * @minimum 0
   * @nullable
   */
  stock?: number | null;
  /**
   * Product low stock alert
   * @minimum 0
   * @nullable
   */
  lowStockAlert?: number | null;
  readonly publicMetadatas?: readonly ProductMetadataProductReadModel[];
}

export type ProductProductReadProductReadSensitiveModelCategory = ProductCategoryProductReadProductReadSensitiveModel | null;

export type ProductProductReadProductReadSensitiveModelBrand = ProductBrandProductReadProductReadSensitiveModel | null;

export interface ProductProductReadProductReadSensitiveModel {
  /** Product ID */
  readonly id: number;
  /**
   * Product name
   * @maxLength 150
   */
  name: string;
  /**
   * Product description
   * @nullable
   */
  description?: string | null;
  /**
   * Product price
   * @minimum 0
   * @nullable
   */
  price?: number | null;
  /** Product point unit */
  pointUnitPrice: number;
  /**
   * Product dynamic quantity
   * @nullable
   */
  readonly dynamicQuantity: number | null;
  /** Product dynamic price */
  dynamicPrice: boolean;
  /** Date and time when the product was created */
  createdAt: string;
  metadatas?: ProductMetadataProductReadProductReadSensitiveModel[];
  images?: MediaProductReadProductReadSensitiveModel[];
  /**
   * @maxLength 255
   * @nullable
   */
  designationCom?: string | null;
  /**
   * @maxLength 20
   * @nullable
   */
  ean?: string | null;
  /** Product archived status */
  isArchived: boolean;
  isDemat: boolean;
  /**
   * Product TVA
   * @minimum 0
   */
  tva: number;
  /**
   * Product shipping price
   * @minimum 0
   */
  shippingPrice: number;
  category?: ProductProductReadProductReadSensitiveModelCategory;
  brand?: ProductProductReadProductReadSensitiveModelBrand;
  /**
   * Product stock
   * @minimum 0
   * @nullable
   */
  stock?: number | null;
  /**
   * Product low stock alert
   * @minimum 0
   * @nullable
   */
  lowStockAlert?: number | null;
  readonly publicMetadatas?: readonly ProductMetadataProductReadProductReadSensitiveModel[];
}

export interface ProductProductStatusJsonMergePatchModel {
  /** Product status (active or not) */
  isActive?: boolean;
  /** Product archived status */
  isArchived?: boolean;
}

export interface ProductProductUpdateJsonMergePatchModel {
  /**
   * Product name
   * @minLength 1
   * @maxLength 150
   */
  name?: string;
  /**
   * Product description
   * @nullable
   */
  description?: string | null;
  /**
   * Product price
   * @minimum 0
   * @nullable
   */
  price?: number | null;
  metadatas?: ProductMetadataProductUpdateModel[];
  /** Product images */
  images?: string[];
  /**
   * @maxLength 255
   * @nullable
   */
  designationCom?: string | null;
  /**
   * @maxLength 20
   * @nullable
   */
  ean?: string | null;
  isDemat?: boolean;
  /** Product TVA */
  tva?: number;
  /** Product shipping price */
  shippingPrice?: number;
  /**
   * Product category
   * @nullable
   */
  category?: string | null;
  /**
   * Product brand
   * @nullable
   */
  brand?: string | null;
  /**
   * Product stock
   * @nullable
   */
  stock?: number | null;
  /**
   * Product low stock alert
   * @nullable
   */
  lowStockAlert?: number | null;
}

export interface ProductProductWriteModel {
  /**
   * Product name
   * @maxLength 150
   */
  name: string;
  /**
   * Product description
   * @nullable
   */
  description?: string | null;
  /**
   * Product price
   * @minimum 0
   * @nullable
   */
  price?: number | null;
  /** Product dynamic price */
  dynamicPrice: boolean;
  metadatas?: ProductMetadataProductWriteModel[];
  /** Shop IRI */
  shop: string;
  /** Product images */
  images?: string[];
  /**
   * @maxLength 255
   * @nullable
   */
  designationCom?: string | null;
  /**
   * @maxLength 20
   * @nullable
   */
  ean?: string | null;
  isDemat: boolean;
  /**
   * Product TVA
   * @minimum 0
   */
  tva: number;
  /**
   * Product shipping price
   * @minimum 0
   */
  shippingPrice: number;
  /**
   * Product category
   * @nullable
   */
  category?: string | null;
  /**
   * Product brand
   * @nullable
   */
  brand?: string | null;
  /**
   * Product stock
   * @minimum 0
   * @nullable
   */
  stock?: number | null;
  /**
   * Product low stock alert
   * @minimum 0
   * @nullable
   */
  lowStockAlert?: number | null;
}

export interface ProductRewardReadModel {
  /** Product ID */
  readonly id: number;
  /**
   * Product name
   * @maxLength 150
   */
  name: string;
  /**
   * Product description
   * @nullable
   */
  description?: string | null;
}

export interface ProductBrandProductReadModel {
  /** Product brand ID */
  readonly id: number;
  /**
   * Product brand name
   * @maxLength 255
   */
  name: string;
  /**
   * Product brand label
   * @maxLength 100
   */
  readonly label: string;
}

export interface ProductBrandProductReadProductReadSensitiveModel {
  /** Product brand ID */
  readonly id: number;
  /**
   * Product brand name
   * @maxLength 255
   */
  name: string;
  /**
   * Product brand label
   * @maxLength 100
   */
  readonly label: string;
}

export interface ProductBrandProductBrandReadModel {
  /** Product brand ID */
  readonly id: number;
  /**
   * Product brand name
   * @maxLength 255
   */
  name: string;
  /**
   * Product brand label
   * @maxLength 100
   */
  readonly label: string;
}

export interface ProductBrandProductBrandWriteModel {
  /**
   * Product brand name
   * @maxLength 255
   */
  name: string;
  /**
   * Product brand label
   * @maxLength 100
   */
  readonly label: string;
}

export interface ProductBrandProductBrandWriteJsonMergePatchModel {
  /**
   * Product brand name
   * @maxLength 255
   */
  name?: string;
  /**
   * Product brand label
   * @maxLength 100
   */
  readonly label?: string;
}

export interface ProductCategoryProductReadModel {
  /** Product category ID */
  readonly id: number;
  /**
   * Product category label
   * @maxLength 100
   */
  label: string;
}

export interface ProductCategoryProductReadProductReadSensitiveModel {
  /** Product category ID */
  readonly id: number;
  /**
   * Product category label
   * @maxLength 100
   */
  label: string;
}

export type ProductCategoryProductCategoryReadModelParent = ProductCategoryProductCategoryReadModel | null;

export interface ProductCategoryProductCategoryReadModel {
  /** Product category ID */
  readonly id: number;
  /**
   * Product category label
   * @maxLength 100
   */
  label: string;
  parent?: ProductCategoryProductCategoryReadModelParent;
  childs?: ProductCategoryProductCategoryReadModel[];
}

export type ProductCategoryProductCategoryWriteModelParent = ProductCategoryProductCategoryWriteModel | null;

export interface ProductCategoryProductCategoryWriteModel {
  /**
   * Product category label
   * @maxLength 100
   */
  label: string;
  parent?: ProductCategoryProductCategoryWriteModelParent;
}

export type ProductCategoryProductCategoryWriteJsonMergePatchModelParent = ProductCategoryProductCategoryWriteModel | null;

export interface ProductCategoryProductCategoryWriteJsonMergePatchModel {
  /**
   * Product category label
   * @maxLength 100
   */
  label?: string;
  parent?: ProductCategoryProductCategoryWriteJsonMergePatchModelParent;
}

/**
 * Metadata key
 * @maxLength 50
 */
export type ProductMetadataOrderReadModelMetaKey = typeof ProductMetadataOrderReadModelMetaKey[keyof typeof ProductMetadataOrderReadModelMetaKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductMetadataOrderReadModelMetaKey = {
  code: 'code',
  codeDetail: 'codeDetail',
  howtoUrl: 'howtoUrl',
} as const;

export interface ProductMetadataOrderReadModel {
  /**
   * Metadata key
   * @maxLength 50
   */
  metaKey: ProductMetadataOrderReadModelMetaKey;
  /** Metadata value */
  metaValue: string;
}

/**
 * Metadata key
 * @maxLength 50
 */
export type ProductMetadataProductReadModelMetaKey = typeof ProductMetadataProductReadModelMetaKey[keyof typeof ProductMetadataProductReadModelMetaKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductMetadataProductReadModelMetaKey = {
  code: 'code',
  codeDetail: 'codeDetail',
  howtoUrl: 'howtoUrl',
} as const;

export interface ProductMetadataProductReadModel {
  /** ProductMetadata ID */
  readonly id: number;
  /**
   * Metadata key
   * @maxLength 50
   */
  metaKey: ProductMetadataProductReadModelMetaKey;
  /** Metadata value */
  metaValue: string;
}

/**
 * Metadata key
 * @maxLength 50
 */
export type ProductMetadataProductReadProductReadSensitiveModelMetaKey = typeof ProductMetadataProductReadProductReadSensitiveModelMetaKey[keyof typeof ProductMetadataProductReadProductReadSensitiveModelMetaKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductMetadataProductReadProductReadSensitiveModelMetaKey = {
  code: 'code',
  codeDetail: 'codeDetail',
  howtoUrl: 'howtoUrl',
} as const;

export interface ProductMetadataProductReadProductReadSensitiveModel {
  /** ProductMetadata ID */
  readonly id: number;
  /**
   * Metadata key
   * @maxLength 50
   */
  metaKey: ProductMetadataProductReadProductReadSensitiveModelMetaKey;
  /** Metadata value */
  metaValue: string;
}

/**
 * Metadata key
 * @maxLength 50
 */
export type ProductMetadataProductUpdateModelMetaKey = typeof ProductMetadataProductUpdateModelMetaKey[keyof typeof ProductMetadataProductUpdateModelMetaKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductMetadataProductUpdateModelMetaKey = {
  code: 'code',
  codeDetail: 'codeDetail',
  howtoUrl: 'howtoUrl',
} as const;

export interface ProductMetadataProductUpdateModel {
  /**
   * Metadata key
   * @maxLength 50
   */
  metaKey: ProductMetadataProductUpdateModelMetaKey;
  /** Metadata value */
  metaValue: string;
}

/**
 * Metadata key
 * @maxLength 50
 */
export type ProductMetadataProductWriteModelMetaKey = typeof ProductMetadataProductWriteModelMetaKey[keyof typeof ProductMetadataProductWriteModelMetaKey];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ProductMetadataProductWriteModelMetaKey = {
  code: 'code',
  codeDetail: 'codeDetail',
  howtoUrl: 'howtoUrl',
} as const;

export interface ProductMetadataProductWriteModel {
  /**
   * Metadata key
   * @maxLength 50
   */
  metaKey: ProductMetadataProductWriteModelMetaKey;
  /** Metadata value */
  metaValue: string;
}

/**
 * Processing status of the proof
 */
export type PurchaseProofPurchaseProofCollectionReadModelStatus = typeof PurchaseProofPurchaseProofCollectionReadModelStatus[keyof typeof PurchaseProofPurchaseProofCollectionReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseProofPurchaseProofCollectionReadModelStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  processing: 'processing',
} as const;

export type PurchaseProofPurchaseProofCollectionReadModelCreatedBy = UserWorkspacePurchaseProofCollectionReadModel | null;

export interface PurchaseProofPurchaseProofCollectionReadModel {
  /** PurchaseProof ID */
  readonly id: number;
  /**
   * Filename of the proof
   * @maxLength 255
   */
  filename: string;
  /**
   * Comment left by the user
   * @nullable
   */
  comment?: string | null;
  /** Processing status of the proof */
  status: PurchaseProofPurchaseProofCollectionReadModelStatus;
  /** Creation date of the proof */
  createdAt: string;
  createdBy?: PurchaseProofPurchaseProofCollectionReadModelCreatedBy;
}

/**
 * Processing status of the proof
 */
export type PurchaseProofPurchaseProofReadModelStatus = typeof PurchaseProofPurchaseProofReadModelStatus[keyof typeof PurchaseProofPurchaseProofReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseProofPurchaseProofReadModelStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  processing: 'processing',
} as const;

export type PurchaseProofPurchaseProofReadModelCreatedBy = UserWorkspacePurchaseProofReadModel | null;

export interface PurchaseProofPurchaseProofReadModel {
  /** PurchaseProof ID */
  readonly id: number;
  /**
   * Filename of the proof
   * @maxLength 255
   */
  filename: string;
  media: MediaPurchaseProofReadModel;
  /**
   * Comment left by the user
   * @nullable
   */
  comment?: string | null;
  /** Processing status of the proof */
  status: PurchaseProofPurchaseProofReadModelStatus;
  /** Creation date of the proof */
  createdAt: string;
  createdBy?: PurchaseProofPurchaseProofReadModelCreatedBy;
  performances?: PerformancePurchaseProofReadModel[];
}

export interface PurchaseProofPurchaseProofSubmitModel {
  /**
   * Filename of the proof
   * @maxLength 255
   */
  filename: string;
  /** Media file associated with the proof */
  media: string;
  /**
   * Comment left by the user
   * @nullable
   */
  comment?: string | null;
}

/**
 * Processing status of the proof
 */
export type PurchaseProofPurchaseProofWriteJsonMergePatchModelStatus = typeof PurchaseProofPurchaseProofWriteJsonMergePatchModelStatus[keyof typeof PurchaseProofPurchaseProofWriteJsonMergePatchModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const PurchaseProofPurchaseProofWriteJsonMergePatchModelStatus = {
  pending: 'pending',
  approved: 'approved',
  rejected: 'rejected',
  processing: 'processing',
} as const;

export interface PurchaseProofPurchaseProofWriteJsonMergePatchModel {
  /** Processing status of the proof */
  status?: PurchaseProofPurchaseProofWriteJsonMergePatchModelStatus;
}

export interface ReferenceBoosterReadModel {
  /** Reference ID */
  readonly id: number;
  /**
   * Brand of the reference
   * @maxLength 100
   */
  brand: string;
  /**
   * Product line of the reference
   * @maxLength 100
   * @nullable
   */
  productLine?: string | null;
  /**
   * Name of the reference
   * @maxLength 100
   */
  name: string;
  /**
   * Unique code of the reference
   * @maxLength 50
   */
  uniqueCode: string;
  /**
   * Point amount given foreach quantity bought, adjusted by the current company's point coefficient. May be null in the GET /references response if the workspace hides reference points
   * @minimum 0
   * @exclusiveMinimum
   */
  pointValue: number;
  /** List of keyword tags for this reference */
  tags?: string[];
}

export interface ReferenceReferenceImportModel {
  /**
   * Brand of the reference
   * @maxLength 100
   */
  brand: string;
  /**
   * Product line of the reference
   * @maxLength 100
   * @nullable
   */
  productLine?: string | null;
  /**
   * Name of the reference
   * @maxLength 100
   */
  name: string;
  /**
   * Unique code of the reference
   * @maxLength 50
   */
  uniqueCode: string;
  /**
   * Point amount given foreach quantity bought, adjusted by the current company's point coefficient. May be null in the GET /references response if the workspace hides reference points
   * @minimum 0
   * @exclusiveMinimum
   */
  pointValue: number;
  /** List of keyword tags for this reference */
  tags?: string[];
}

export type ReferenceReferenceReadModelActiveBooster = BoosterReferenceReadModel | null;

export interface ReferenceReferenceReadModel {
  /** Reference ID */
  readonly id: number;
  /**
   * Brand of the reference
   * @maxLength 100
   */
  brand: string;
  /**
   * Product line of the reference
   * @maxLength 100
   * @nullable
   */
  productLine?: string | null;
  /**
   * Name of the reference
   * @maxLength 100
   */
  name: string;
  /**
   * Unique code of the reference
   * @maxLength 50
   */
  uniqueCode: string;
  /**
   * Point amount given foreach quantity bought, adjusted by the current company's point coefficient. May be null in the GET /references response if the workspace hides reference points
   * @minimum 0
   * @exclusiveMinimum
   */
  pointValue: number;
  /** List of keyword tags for this reference */
  tags?: string[];
  activeBooster?: ReferenceReferenceReadModelActiveBooster;
  readonly activeBoosterTiers?: readonly BoosterReferenceReferenceReadModel[];
}

export type RewardGroupedRewardReadModelTypology = TypologyGroupedRewardReadModel | null;

/**
 * Status of the reward
 */
export type RewardGroupedRewardReadModelStatus = typeof RewardGroupedRewardReadModelStatus[keyof typeof RewardGroupedRewardReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RewardGroupedRewardReadModelStatus = {
  enabled: 'enabled',
  disabled: 'disabled',
} as const;

export interface RewardGroupedRewardReadModel {
  /** Reward ID */
  readonly id?: number;
  typology?: RewardGroupedRewardReadModelTypology;
  product: ProductGroupedRewardReadModel;
  /** Status of the reward */
  status: RewardGroupedRewardReadModelStatus;
  isArchived: boolean;
}

export interface RewardRewardPatchJsonMergePatchModel {
  /** Product associated to the reward */
  product?: string;
}

export type RewardRewardReadModelTypology = TypologyRewardReadModel | null;

/**
 * Status of the reward
 */
export type RewardRewardReadModelStatus = typeof RewardRewardReadModelStatus[keyof typeof RewardRewardReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RewardRewardReadModelStatus = {
  enabled: 'enabled',
  disabled: 'disabled',
} as const;

export interface RewardRewardReadModel {
  /** Reward ID */
  readonly id?: number;
  typology?: RewardRewardReadModelTypology;
  step: LogicTypeStepRewardReadModel;
  product: ProductRewardReadModel;
  /** Status of the reward */
  status: RewardRewardReadModelStatus;
  isArchived: boolean;
}

export interface RewardRewardWriteModel {
  /**
   * Typology of the reward
   * @nullable
   */
  typology?: string | null;
  /** Step associated to the reward */
  step: string;
  /** Product associated to the reward */
  product: string;
}

export interface RewardGroupedRewardGroupedRewardReadModel {
  step?: LogicTypeStepGroupedRewardReadModel;
  rewards?: RewardGroupedRewardReadModel[];
}

export interface RouteRouteReadModel {
  /**
   * Path of the route
   * @maxLength 50
   */
  path: string;
}

export interface RouteRouteWriteModel {
  /**
   * Path of the route
   * @maxLength 50
   */
  path: string;
  /** Is the route for admin frontend or for user frontend */
  forAdmin: boolean;
  /** Security expression to verify route access */
  securityExpression: string;
}

export interface SalesHierarchySalesHierarchyReadModel {
  /** Hierarchy ID */
  readonly id: number;
  /**
   * Hierarchy name
   * @maxLength 50
   */
  name: string;
  /** Hierarchy creation date */
  createdAt: string;
  parents: UserWorkspaceSalesHierarchyReadModel[];
  /** Number of sales placed in this hierarchy, excluding head(s) */
  subordinatesCount: number;
}

export interface SalesHierarchySalesHierarchyWriteModel {
  /**
   * Hierarchy name
   * @maxLength 50
   */
  name: string;
}

export interface SalesHierarchySalesHierarchyWriteJsonMergePatchModel {
  /**
   * Hierarchy name
   * @maxLength 50
   */
  name?: string;
}

export type SalesHierarchySalesHierarchyLinkSalesHierarchyLinkTreeReadModelSales = UserWorkspaceSalesHierarchyLinkTreeReadModel | null;

export interface SalesHierarchySalesHierarchyLinkSalesHierarchyLinkTreeReadModel {
  /** Link ID */
  readonly id: number;
  subLinks?: SalesHierarchyLinkSalesHierarchyLinkTreeReadModel[];
  readonly sales?: SalesHierarchySalesHierarchyLinkSalesHierarchyLinkTreeReadModelSales;
}

export interface SalesHierarchyLinkSalesHierarchyLinkReadModel {
  /** Link ID */
  readonly id: number;
  /** IRI of the sales hierarchy this link belongs to */
  hierarchy: string;
  parent: UserWorkspaceSalesHierarchyLinkReadModel;
  child: UserWorkspaceSalesHierarchyLinkReadModel;
  /** Link creation date */
  createdAt: string;
}

export type SalesHierarchyLinkSalesHierarchyLinkTreeReadModelSales = UserWorkspaceSalesHierarchyLinkTreeReadModel | null;

export interface SalesHierarchyLinkSalesHierarchyLinkTreeReadModel {
  /** Link ID */
  readonly id: number;
  subLinks?: SalesHierarchyLinkSalesHierarchyLinkTreeReadModel[];
  readonly sales?: SalesHierarchyLinkSalesHierarchyLinkTreeReadModelSales;
}

export interface SalesHierarchyLinkSalesHierarchyLinkWriteModel {
  /** IRI of the sales hierarchy this link belongs to */
  hierarchy: string;
  /** IRI of the N+1 (parent) user workspace */
  parent: string;
  /** IRI of the N (child) user workspace being attached */
  child: string;
}

/**
 * Task name
 * @maxLength 30
 */
export type ScheduledTaskScheduledTaskReadModelName = typeof ScheduledTaskScheduledTaskReadModelName[keyof typeof ScheduledTaskScheduledTaskReadModelName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduledTaskScheduledTaskReadModelName = {
  steps_export: 'steps_export',
  targets_export: 'targets_export',
} as const;

export type ScheduledTaskScheduledTaskReadModelCurrentUserScheduledTask = UserScheduledTaskScheduledTaskReadModel | null;

export interface ScheduledTaskScheduledTaskReadModel {
  /** User scheduled task ID */
  readonly id: number;
  /**
   * Task name
   * @maxLength 30
   */
  name: ScheduledTaskScheduledTaskReadModelName;
  /**
   * Task description
   * @maxLength 255
   */
  description: string;
  readonly currentUserScheduledTask: ScheduledTaskScheduledTaskReadModelCurrentUserScheduledTask;
}

/**
 * Task name
 * @maxLength 30
 */
export type ScheduledTaskUserScheduledTaskReadModelName = typeof ScheduledTaskUserScheduledTaskReadModelName[keyof typeof ScheduledTaskUserScheduledTaskReadModelName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ScheduledTaskUserScheduledTaskReadModelName = {
  steps_export: 'steps_export',
  targets_export: 'targets_export',
} as const;

export interface ScheduledTaskUserScheduledTaskReadModel {
  /** User scheduled task ID */
  readonly id: number;
  /**
   * Task name
   * @maxLength 30
   */
  name: ScheduledTaskUserScheduledTaskReadModelName;
}

export interface SegmentSegmentCollectionReadModel {
  /** Segment ID */
  readonly id: number;
  /**
   * Name of the segment
   * @maxLength 255
   */
  name: string;
  /**
   * Description of the segment
   * @nullable
   */
  description?: string | null;
  /** Creation date of the segment */
  createdAt: string;
  createdBy: UserWorkspaceSegmentCollectionReadModel;
  /** Number of rules attached to the segment */
  rulesCount: number;
}

export interface SegmentSegmentReadModel {
  /** Segment ID */
  readonly id: number;
  /**
   * Name of the segment
   * @maxLength 255
   */
  name: string;
  /**
   * Description of the segment
   * @nullable
   */
  description?: string | null;
  /** Creation date of the segment */
  createdAt: string;
  createdBy: UserWorkspaceSegmentReadModel;
  rules?: SegmentRuleSegmentReadModel[];
}

export interface SegmentSegmentUpdateJsonMergePatchModel {
  /**
   * Name of the segment
   * @maxLength 255
   */
  name?: string;
  /**
   * Description of the segment
   * @nullable
   */
  description?: string | null;
  rules?: SegmentRuleSegmentUpdateModel[];
}

export interface SegmentSegmentWriteModel {
  /**
   * Name of the segment
   * @maxLength 255
   */
  name: string;
  /**
   * Description of the segment
   * @nullable
   */
  description?: string | null;
}

export interface SegmentSegmentEntityCollectionReadModel {
  /** Segment ID */
  readonly id: number;
  /**
   * Name of the segment
   * @maxLength 255
   */
  name: string;
  /**
   * Description of the segment
   * @nullable
   */
  description?: string | null;
}

export type SegmentCriterionSegmentCriterionReadModelChoicesItemAnyOf = {[key: string]: number | string};

export type SegmentCriterionSegmentCriterionReadModelChoicesItem = SegmentCriterionSegmentCriterionReadModelChoicesItemAnyOf | string;

export interface SegmentCriterionSegmentCriterionReadModel {
  /** Field identifier to use as the "field" of a SegmentRule */
  field: string;
  /** Translation key describing this criterion, always "segment.criterion.{field}" */
  label: string;
  /** Field type, determines which operators and value format are valid */
  type: string;
  /** Operators allowed for this field, to use as the "operator" of a SegmentRule */
  operators: string[];
  /**
   * Allowed values for "choice" type fields, to use as the "value" of a SegmentRule. Null for "text" type fields. For fixed (PHP enum) choice fields, each item is a plain string. For workspace-specific (dynamic) choice fields (e.g. company.typology.id), each item is an { id, name } object — submit "id" as the rule's value.
   * @nullable
   */
  choices?: SegmentCriterionSegmentCriterionReadModelChoicesItem[] | null;
}

export interface SegmentEntitySegmentEntityCollectionReadModel {
  /** SegmentEntity link ID */
  readonly id: number;
  segment?: SegmentSegmentEntityCollectionReadModel;
  /** Date the segment was attached to the entity */
  createdAt: string;
}

/**
 * Short code of the target entity type
 */
export type SegmentEntitySegmentEntityReadModelType = typeof SegmentEntitySegmentEntityReadModelType[keyof typeof SegmentEntitySegmentEntityReadModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentEntitySegmentEntityReadModelType = {
  shop: 'shop',
  widget: 'widget',
  game: 'game',
} as const;

export interface SegmentEntitySegmentEntityReadModel {
  /** SegmentEntity link ID */
  readonly id: number;
  /**
   * ID of the target entity
   * @minimum 0
   * @exclusiveMinimum
   */
  entityId: number;
  /** Date the segment was attached to the entity */
  createdAt: string;
  /** Short code of the target entity type */
  type: SegmentEntitySegmentEntityReadModelType;
}

/**
 * Short code of the target entity type
 */
export type SegmentEntitySegmentEntityWriteModelType = typeof SegmentEntitySegmentEntityWriteModelType[keyof typeof SegmentEntitySegmentEntityWriteModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentEntitySegmentEntityWriteModelType = {
  shop: 'shop',
  widget: 'widget',
  game: 'game',
} as const;

export interface SegmentEntitySegmentEntityWriteModel {
  /**
   * ID of the target entity
   * @minimum 0
   * @exclusiveMinimum
   */
  entityId: number;
  /** Short code of the target entity type */
  type: SegmentEntitySegmentEntityWriteModelType;
}

export interface SegmentPreviewSegmentPreviewReadModel {
  /** Number of workspace members that would match all the given rules */
  matchingCount: number;
}

export interface SegmentPreviewSegmentPreviewWriteModel {
  rules?: SegmentRuleSegmentPreviewWriteModel[];
}

/**
 * Field identifier to use
 */
export type SegmentRuleSegmentReadModelField = typeof SegmentRuleSegmentReadModelField[keyof typeof SegmentRuleSegmentReadModelField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentRuleSegmentReadModelField = {
  status: 'status',
  companyzipcode: 'company.zipcode',
  companystatus: 'company.status',
  companytypologyid: 'company.typology.id',
} as const;

/**
 * Operator to use
 */
export type SegmentRuleSegmentReadModelOperator = typeof SegmentRuleSegmentReadModelOperator[keyof typeof SegmentRuleSegmentReadModelOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentRuleSegmentReadModelOperator = {
  equals: 'equals',
  not_equals: 'not_equals',
  starts_with: 'starts_with',
  ends_with: 'ends_with',
  contains: 'contains',
} as const;

export interface SegmentRuleSegmentReadModel {
  readonly id?: number;
  /** Field identifier to use */
  field: SegmentRuleSegmentReadModelField;
  /** Operator to use */
  operator: SegmentRuleSegmentReadModelOperator;
  /**
   * Value to compare to
   * @maxLength 255
   */
  value: string;
}

/**
 * Field identifier to use
 */
export type SegmentRuleSegmentUpdateModelField = typeof SegmentRuleSegmentUpdateModelField[keyof typeof SegmentRuleSegmentUpdateModelField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentRuleSegmentUpdateModelField = {
  status: 'status',
  companyzipcode: 'company.zipcode',
  companystatus: 'company.status',
  companytypologyid: 'company.typology.id',
} as const;

/**
 * Operator to use
 */
export type SegmentRuleSegmentUpdateModelOperator = typeof SegmentRuleSegmentUpdateModelOperator[keyof typeof SegmentRuleSegmentUpdateModelOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentRuleSegmentUpdateModelOperator = {
  equals: 'equals',
  not_equals: 'not_equals',
  starts_with: 'starts_with',
  ends_with: 'ends_with',
  contains: 'contains',
} as const;

export interface SegmentRuleSegmentUpdateModel {
  /** Field identifier to use */
  field: SegmentRuleSegmentUpdateModelField;
  /** Operator to use */
  operator: SegmentRuleSegmentUpdateModelOperator;
  /**
   * Value to compare to
   * @maxLength 255
   */
  value: string;
}

/**
 * Field identifier to use
 */
export type SegmentRuleSegmentPreviewWriteModelField = typeof SegmentRuleSegmentPreviewWriteModelField[keyof typeof SegmentRuleSegmentPreviewWriteModelField];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentRuleSegmentPreviewWriteModelField = {
  status: 'status',
  companyzipcode: 'company.zipcode',
  companystatus: 'company.status',
  companytypologyid: 'company.typology.id',
} as const;

/**
 * Operator to use
 */
export type SegmentRuleSegmentPreviewWriteModelOperator = typeof SegmentRuleSegmentPreviewWriteModelOperator[keyof typeof SegmentRuleSegmentPreviewWriteModelOperator];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const SegmentRuleSegmentPreviewWriteModelOperator = {
  equals: 'equals',
  not_equals: 'not_equals',
  starts_with: 'starts_with',
  ends_with: 'ends_with',
  contains: 'contains',
} as const;

export interface SegmentRuleSegmentPreviewWriteModel {
  /** Field identifier to use */
  field: SegmentRuleSegmentPreviewWriteModelField;
  /** Operator to use */
  operator: SegmentRuleSegmentPreviewWriteModelOperator;
  /**
   * Value to compare to
   * @maxLength 255
   */
  value: string;
}

export interface ShopCompanyReadModel {
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName: string;
}

export interface ShopOrderCollectionReadModel {
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName: string;
  logo: MediaOrderCollectionReadModel;
}

export interface ShopOrderReadModel {
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName: string;
  logo: MediaOrderReadModel;
}

export interface ShopShopUpdateJsonMergePatchModel {
  /**
   * Shop name
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName?: string;
  /**
   * Shop description (label)
   * @minLength 1
   * @maxLength 255
   */
  description?: string;
  /** Shop logo */
  logo?: string;
  /**
   * Shop banner
   * @nullable
   */
  banner?: string | null;
  /** Shop maintenance status */
  isMaintenance?: boolean;
  /**
   * @maxLength 255
   * @nullable
   */
  operationalContact?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  technicalContact?: string | null;
}

/**
 * Shop type
 * @maxLength 10
 */
export type ShopShopWriteModelType = typeof ShopShopWriteModelType[keyof typeof ShopShopWriteModelType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ShopShopWriteModelType = {
  provider: 'provider',
  reward: 'reward',
  custom: 'custom',
} as const;

export interface ShopShopWriteModel {
  /**
   * Shop name
   * @maxLength 100
   */
  name: string;
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName: string;
  /**
   * Shop description (label)
   * @maxLength 255
   */
  description: string;
  /**
   * Shop type
   * @maxLength 10
   */
  type: ShopShopWriteModelType;
  /** Shop logo */
  logo: string;
  /**
   * Shop banner
   * @nullable
   */
  banner?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  operationalContact?: string | null;
  /**
   * @maxLength 255
   * @nullable
   */
  technicalContact?: string | null;
}

export interface ShopShopWorkspaceReadModel {
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName: string;
}

export interface ShopWorkspaceReadModel {
  /** Shop ID */
  readonly id: number;
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName: string;
}

export interface ShopWorkspaceReadAdminWorkspaceReadModel {
  /** Shop ID */
  readonly id: number;
  /**
   * Shop display name
   * @maxLength 100
   */
  displayName: string;
}

export interface ShopWorkspaceShopWorkspaceReadModel {
  /** Shop Workspace ID */
  readonly id: number;
  shop: ShopShopWorkspaceReadModel;
  /**
   * Minimum point before provider can be used
   * @minimum 0
   */
  minPoint?: number;
  /**
   * Marge coefficient
   * @minimum 1
   */
  coefficient?: number;
  /**
   * Shop opening date
   * @nullable
   */
  shopOpeningDate?: string | null;
  /**
   * Shop closing date
   * @nullable
   */
  shopClosingDate?: string | null;
  /** Shop workspace is active */
  isActive?: boolean;
  isActivable?: boolean;
}

export interface ShopWorkspaceShopWorkspaceUpdateJsonMergePatchModel {
  /**
   * Minimum point before provider can be used
   * @minimum 0
   */
  minPoint?: number;
  /**
   * Marge coefficient
   * @minimum 1
   */
  coefficient?: number;
  /**
   * Shop opening date
   * @nullable
   */
  shopOpeningDate?: string | null;
  /**
   * Shop closing date
   * @nullable
   */
  shopClosingDate?: string | null;
  /** Shop workspace is active */
  isActive?: boolean;
}

export interface ShopWorkspaceShopWorkspaceWriteModel {
  /** Shop IRI */
  shop: string;
}

export interface TypologyCompanyCollectionReadModel {
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
}

export interface TypologyCompanyReadModel {
  /** Typology ID */
  readonly id: number;
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
}

export interface TypologyGroupedRewardReadModel {
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
}

export interface TypologyOrderReadModel {
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
}

export interface TypologyRewardReadModel {
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
}

export interface TypologyTypologyReadModel {
  /** Typology ID */
  readonly id: number;
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
  /**
   * Coefficient of the typology (conversion euros => points)
   * @minimum 0
   */
  pointCoeff: number;
  /** Typology used by default */
  isDefault: boolean;
  /** Date of creation of the typology */
  createdAt: string;
}

export interface TypologyTypologyUpdateJsonMergePatchModel {
  /**
   * Name of the typology
   * @minLength 1
   * @maxLength 100
   */
  name?: string;
  /**
   * Coefficient of the typology (conversion euros => points)
   * @minimum 0
   */
  pointCoeff?: number;
  /** Typology used by default */
  isDefault?: boolean;
}

export interface TypologyWaitingListReadModel {
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
}

export interface TypologyWorkspaceReadModel {
  /** Typology ID */
  readonly id: number;
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
}

export interface TypologyWorkspaceReadAdminWorkspaceReadModel {
  /** Typology ID */
  readonly id: number;
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
}

export interface TypologyWorkspaceWriteModel {
  /**
   * Name of the typology
   * @maxLength 100
   */
  name: string;
  /**
   * Coefficient of the typology (conversion euros => points)
   * @minimum 0
   */
  pointCoeff: number;
  /** Typology used by default */
  isDefault: boolean;
}

export interface UpdateCompanyDtoModel {
  data: UpdateCompanyItemDtoModel[];
}

export interface UpdateCompanyDtoCompanyUpdateJsonMergePatchModel {
  data?: UpdateCompanyItemDtoCompanyUpdateModel[];
}

export interface UpdateCompanyItemDtoModel {
  /**
   * ID of the company to update
   * @nullable
   */
  id: number | null;
  /**
   * Company data to update
   * @nullable
   */
  company: string | null;
}

export type UpdateCompanyItemDtoCompanyUpdateModelCompany = CompanyCompanyUpdateModel | null;

export interface UpdateCompanyItemDtoCompanyUpdateModel {
  /**
   * ID of the company to update
   * @nullable
   */
  id: number | null;
  company: UpdateCompanyItemDtoCompanyUpdateModelCompany;
}

export interface UserCompanyCollectionReadModel {
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserCompanyReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserCompanyResponsibleReadModel {
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserEmailReadModel {
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserGameCollectionReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserGameReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserMeReadModel {
  /** User ID */
  readonly id: number;
  /**
   * User email
   * @maxLength 255
   */
  email: string;
  visibleWorkspaces: UserWorkspaceMeReadModel[];
  /**
   * User firstname
   * @maxLength 50
   */
  firstname: string;
  /**
   * User lastname
   * @maxLength 50
   */
  lastname: string;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserOrderCollectionReadModel {
  /** User ID */
  readonly id: number;
  /**
   * User email
   * @maxLength 255
   */
  email: string;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserOrderReadModel {
  /** User ID */
  readonly id: number;
  /**
   * User email
   * @maxLength 255
   */
  email: string;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserPerformanceCollectionReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserPerformanceReadModel {
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserPointCollectionReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserPointReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserPurchaseProofCollectionReadModel {
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserPurchaseProofReadModel {
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserSalesHierarchyReadModel {
  /** User fullname */
  fullname: string;
}

export interface UserSalesHierarchyLinkReadModel {
  /** User fullname */
  fullname: string;
}

export interface UserSalesHierarchyLinkTreeReadModel {
  /** User fullname */
  fullname: string;
}

export interface UserSegmentCollectionReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserSegmentMemberReadModel {
  /** User ID */
  readonly id: number;
  /**
   * User email
   * @maxLength 255
   */
  email: string;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserSegmentReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserUserCollectionReadModel {
  /** User ID */
  readonly id: number;
  /**
   * User email
   * @maxLength 255
   */
  email: string;
  userWorkspaces: UserWorkspaceUserCollectionReadModel[];
  /**
   * User firstname
   * @maxLength 50
   */
  firstname: string;
  /**
   * User lastname
   * @maxLength 50
   */
  lastname: string;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserUserReadModel {
  /** User ID */
  readonly id: number;
  /**
   * User email
   * @maxLength 255
   */
  email: string;
  userWorkspaces: UserWorkspaceUserReadModel[];
  /**
   * User firstname
   * @maxLength 50
   */
  firstname: string;
  /**
   * User lastname
   * @maxLength 50
   */
  lastname: string;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserUserSendFirstConnexionModel {
  /**
   * User email
   * @maxLength 255
   */
  email: string;
}

export interface UserUserUpdateJsonMergePatchModel {
  /**
   * User email
   * @minLength 1
   * @maxLength 255
   */
  email?: string;
  /**
   * User plain password
   * @minLength 8
   * @nullable
   * @pattern ^((?=.*[a-z])(?=.*[A-Z])(?=.*\d).+)$
   */
  plainPassword?: string | null;
  userWorkspace?: UserWorkspaceUserUpdateModel;
  /**
   * User firstname
   * @minLength 1
   * @maxLength 50
   */
  firstname?: string;
  /**
   * User lastname
   * @minLength 1
   * @maxLength 50
   */
  lastname?: string;
}

export interface UserUserHistoryReadModel {
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserWaitingListReadModel {
  /** User ID */
  readonly id: number;
  /** User fullname */
  fullname: string;
  /**
   * User avatar
   * @maxLength 255
   * @nullable
   */
  avatar?: string | null;
  /** Whether the entity has been soft-deleted */
  readonly isDeleted: boolean;
}

export interface UserHistoryUserHistoryReadModel {
  /**
   * User field that was updated
   * @maxLength 255
   */
  property: string;
  /** User field old value */
  previousValue: string;
  /** User field new value */
  newValue: string;
  /** History creation date */
  createdAt: string;
  madeByUser: UserUserHistoryReadModel;
}

export interface UserHistoryLoginUserHistoryLoginReadModel {
  readonly id: number;
  /** Date of the connection */
  connectedAt: string;
}

export interface UserScheduledTaskScheduledTaskReadModel {
  /** User scheduled task ID */
  readonly id: number;
}

export interface UserScheduledTaskUserScheduledTaskReadModel {
  /** User scheduled task ID */
  readonly id: number;
  scheduledTask: ScheduledTaskUserScheduledTaskReadModel;
}

export interface UserScheduledTaskUserScheduledTaskWriteModel {
  /** Scheduled task IRI */
  scheduledTask: string;
}

export interface UserWorkspaceCompanyCollectionReadModel {
  user: UserCompanyCollectionReadModel;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
}

export interface UserWorkspaceCompanyResponsibleReadModel {
  user: UserCompanyResponsibleReadModel;
}

export interface UserWorkspaceEmailReadModel {
  user: UserEmailReadModel;
}

export interface UserWorkspaceGameCollectionReadModel {
  user: UserGameCollectionReadModel;
}

export interface UserWorkspaceGameReadModel {
  user: UserGameReadModel;
}

export interface UserWorkspaceOrderCollectionReadModel {
  user: UserOrderCollectionReadModel;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
  /**
   * User phone number
   * @maxLength 20
   * @nullable
   */
  phone?: string | null;
}

export interface UserWorkspaceOrderReadModel {
  user: UserOrderReadModel;
  /**
   * User phone number
   * @maxLength 20
   * @nullable
   */
  phone?: string | null;
}

export interface UserWorkspacePerformanceCollectionReadModel {
  user: UserPerformanceCollectionReadModel;
}

export interface UserWorkspacePerformanceReadModel {
  user: UserPerformanceReadModel;
}

export interface UserWorkspacePointCollectionReadModel {
  user: UserPointCollectionReadModel;
}

export interface UserWorkspacePointReadModel {
  user: UserPointReadModel;
}

export type UserWorkspacePurchaseProofCollectionReadModelCompany = CompanyPurchaseProofCollectionReadModel | null;

export interface UserWorkspacePurchaseProofCollectionReadModel {
  user: UserPurchaseProofCollectionReadModel;
  company?: UserWorkspacePurchaseProofCollectionReadModelCompany;
}

export interface UserWorkspacePurchaseProofReadModel {
  user: UserPurchaseProofReadModel;
}

/**
 * User max role
 */
export type UserWorkspaceSalesHierarchyReadModelMaxRole = typeof UserWorkspaceSalesHierarchyReadModelMaxRole[keyof typeof UserWorkspaceSalesHierarchyReadModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceSalesHierarchyReadModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export interface UserWorkspaceSalesHierarchyReadModel {
  user: UserSalesHierarchyReadModel;
  /** User max role */
  maxRole?: UserWorkspaceSalesHierarchyReadModelMaxRole;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
}

/**
 * User max role
 */
export type UserWorkspaceSalesHierarchyLinkReadModelMaxRole = typeof UserWorkspaceSalesHierarchyLinkReadModelMaxRole[keyof typeof UserWorkspaceSalesHierarchyLinkReadModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceSalesHierarchyLinkReadModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export interface UserWorkspaceSalesHierarchyLinkReadModel {
  user: UserSalesHierarchyLinkReadModel;
  /** User max role */
  maxRole?: UserWorkspaceSalesHierarchyLinkReadModelMaxRole;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
}

/**
 * User max role
 */
export type UserWorkspaceSalesHierarchyLinkTreeReadModelMaxRole = typeof UserWorkspaceSalesHierarchyLinkTreeReadModelMaxRole[keyof typeof UserWorkspaceSalesHierarchyLinkTreeReadModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceSalesHierarchyLinkTreeReadModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export interface UserWorkspaceSalesHierarchyLinkTreeReadModel {
  user: UserSalesHierarchyLinkTreeReadModel;
  /** User max role */
  maxRole?: UserWorkspaceSalesHierarchyLinkTreeReadModelMaxRole;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
}

export interface UserWorkspaceSegmentCollectionReadModel {
  user: UserSegmentCollectionReadModel;
}

export type UserWorkspaceSegmentMemberReadModelCompany = CompanySegmentMemberReadModel | null;

export interface UserWorkspaceSegmentMemberReadModel {
  readonly id?: number;
  user: UserSegmentMemberReadModel;
  company?: UserWorkspaceSegmentMemberReadModelCompany;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
}

export interface UserWorkspaceSegmentReadModel {
  user: UserSegmentReadModel;
}

/**
 * User max role
 */
export type UserWorkspaceUserUpdateModelMaxRole = typeof UserWorkspaceUserUpdateModelMaxRole[keyof typeof UserWorkspaceUserUpdateModelMaxRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceUserUpdateModelMaxRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

/**
 * User status
 */
export type UserWorkspaceUserUpdateModelStatus = typeof UserWorkspaceUserUpdateModelStatus[keyof typeof UserWorkspaceUserUpdateModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UserWorkspaceUserUpdateModelStatus = {
  userstatusunregistered: 'user.status.unregistered',
  userstatusregistered: 'user.status.registered',
  userstatusblocked: 'user.status.blocked',
  userstatusinactive: 'user.status.inactive',
} as const;

export interface UserWorkspaceUserUpdateModel {
  /** User max role */
  maxRole?: UserWorkspaceUserUpdateModelMaxRole;
  /**
   * The company unique code to which the user belongs
   * @nullable
   */
  companyUniqueCode?: string | null;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
  /** User status */
  status?: UserWorkspaceUserUpdateModelStatus;
  /**
   * User phone number
   * @maxLength 20
   * @nullable
   */
  phone?: string | null;
  /**
   * Comment about the user
   * @nullable
   */
  comment?: string | null;
  /**
   * Additional customizable comment about the user
   * @nullable
   */
  comment2?: string | null;
  /**
   * Additional customizable comment about the user
   * @nullable
   */
  comment3?: string | null;
}

export interface UserWorkspaceWaitingListReadModel {
  user: UserWaitingListReadModel;
}

export interface UserWorkspaceWorkspaceInviteModel {
  /** User IRI */
  user: string;
  /**
   * User unique code
   * @minLength 1
   * @maxLength 50
   * @pattern ^([a-zA-Z0-9]+)$
   */
  uniqueCode?: string;
}

export interface ValuePerMonthCompanyReadModel {
  /** Value in this month */
  value: number;
  /** Month of the year (1-12) */
  month: number;
  /** Year */
  year: number;
}

export interface ValuePerMonthInsightOrderReadModel {
  /** Value in this month */
  value: number;
  /** Month of the year (1-12) */
  month: number;
  /** Year */
  year: number;
}

export interface ValuePerMonthInsightPerformanceReadModel {
  /** Value in this month */
  value: number;
  /** Month of the year (1-12) */
  month: number;
  /** Year */
  year: number;
}

export interface ValuePerMonthInsightPointReadModel {
  /** Value in this month */
  value: number;
  /** Month of the year (1-12) */
  month: number;
  /** Year */
  year: number;
}

export interface ValuePerMonthInsightUserMeReadModel {
  /** Value in this month */
  value: number;
  /** Month of the year (1-12) */
  month: number;
  /** Year */
  year: number;
}

export interface ValuePerMonthMeReadModel {
  /** Value in this month */
  value: number;
  /** Month of the year (1-12) */
  month: number;
  /** Year */
  year: number;
}

export interface ValuePerMonthUserReadModel {
  /** Value in this month */
  value: number;
  /** Month of the year (1-12) */
  month: number;
  /** Year */
  year: number;
}

export interface VideoNoticeVideoNoticeCollectionReadModel {
  /** VideoNotice ID */
  readonly id: number;
  /**
   * Title of the video notice
   * @maxLength 255
   */
  title: string;
  /**
   * Description of the video notice
   * @nullable
   */
  description?: string | null;
  /**
   * Link to the video
   * @maxLength 255
   */
  videoUrl: string;
  /**
   * Category (tag) of the video notice
   * @maxLength 255
   * @nullable
   */
  category?: string | null;
  /** Creation date of the video notice */
  createdAt: string;
  /** Last update date of the video notice */
  updatedAt: string;
}

export interface VideoNoticeVideoNoticeReadModel {
  /** VideoNotice ID */
  readonly id: number;
  /**
   * Title of the video notice
   * @maxLength 255
   */
  title: string;
  /**
   * Description of the video notice
   * @nullable
   */
  description?: string | null;
  /**
   * Link to the video
   * @maxLength 255
   */
  videoUrl: string;
  /**
   * Category (tag) of the video notice
   * @maxLength 255
   * @nullable
   */
  category?: string | null;
  /** Creation date of the video notice */
  createdAt: string;
  /** Last update date of the video notice */
  updatedAt: string;
}

export interface VideoNoticeVideoNoticeUpdateJsonMergePatchModel {
  /**
   * Title of the video notice
   * @maxLength 255
   */
  title?: string;
  /**
   * Description of the video notice
   * @nullable
   */
  description?: string | null;
  /**
   * Link to the video
   * @maxLength 255
   */
  videoUrl?: string;
  /**
   * Category (tag) of the video notice
   * @maxLength 255
   * @nullable
   */
  category?: string | null;
}

export interface VideoNoticeVideoNoticeWriteModel {
  /**
   * Title of the video notice
   * @maxLength 255
   */
  title: string;
  /**
   * Description of the video notice
   * @nullable
   */
  description?: string | null;
  /**
   * Link to the video
   * @maxLength 255
   */
  videoUrl: string;
  /**
   * Category (tag) of the video notice
   * @maxLength 255
   * @nullable
   */
  category?: string | null;
}

export type WaitingListWaitingListReadModelCountry = CountryWaitingListReadModel | null;

export type WaitingListWaitingListReadModelResponsible = UserWorkspaceWaitingListReadModel | null;

export type WaitingListWaitingListReadModelTypology = TypologyWaitingListReadModel | null;

/**
 * User role, front user role accepted
 * @maxLength 50
 * @nullable
 */
export type WaitingListWaitingListReadModelRole = typeof WaitingListWaitingListReadModelRole[keyof typeof WaitingListWaitingListReadModelRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WaitingListWaitingListReadModelRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
} as const;

/**
 * Waiting list status
 * @maxLength 30
 */
export type WaitingListWaitingListReadModelStatus = typeof WaitingListWaitingListReadModelStatus[keyof typeof WaitingListWaitingListReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WaitingListWaitingListReadModelStatus = {
  waitingliststatuspending: 'waiting.list.status.pending',
  waitingliststatusapproved: 'waiting.list.status.approved',
  waitingliststatusrejected: 'waiting.list.status.rejected',
} as const;

export interface WaitingListWaitingListReadModel {
  /** WaitingList ID */
  readonly id: number;
  /**
   * Company name
   * @maxLength 100
   * @nullable
   */
  companyName?: string | null;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @nullable
   */
  companyUniqueCode?: string | null;
  /**
   * Company address line 1
   * @maxLength 255
   * @nullable
   */
  addressLine1?: string | null;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @maxLength 20
   * @nullable
   */
  zipcode?: string | null;
  /**
   * Company city
   * @maxLength 100
   * @nullable
   */
  city?: string | null;
  /** Company creation date */
  createdAt: string;
  country?: WaitingListWaitingListReadModelCountry;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  responsible?: WaitingListWaitingListReadModelResponsible;
  typology?: WaitingListWaitingListReadModelTypology;
  /**
   * Coefficient used to calculate points (depending conversion type)
   * @minimum 0
   * @nullable
   */
  pointCoeff?: number | null;
  /**
   * User email
   * @maxLength 255
   * @nullable
   */
  email?: string | null;
  /**
   * User firstname
   * @maxLength 50
   * @nullable
   */
  firstname?: string | null;
  /**
   * User lastname
   * @maxLength 50
   * @nullable
   */
  lastname?: string | null;
  /**
   * User unique code
   * @maxLength 50
   * @nullable
   */
  userUniqueCode?: string | null;
  /**
   * User role, front user role accepted
   * @maxLength 50
   * @nullable
   */
  role?: WaitingListWaitingListReadModelRole;
  /**
   * Comment about the company in waiting list
   * @nullable
   */
  comment?: string | null;
  /**
   * Waiting list status
   * @maxLength 30
   */
  status: WaitingListWaitingListReadModelStatus;
  createdBy: UserWorkspaceWaitingListReadModel;
}

/**
 * Waiting list status
 * @maxLength 30
 */
export type WaitingListWaitingListSubmitJsonMergePatchModelStatus = typeof WaitingListWaitingListSubmitJsonMergePatchModelStatus[keyof typeof WaitingListWaitingListSubmitJsonMergePatchModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WaitingListWaitingListSubmitJsonMergePatchModelStatus = {
  waitingliststatuspending: 'waiting.list.status.pending',
  waitingliststatusapproved: 'waiting.list.status.approved',
  waitingliststatusrejected: 'waiting.list.status.rejected',
} as const;

export interface WaitingListWaitingListSubmitJsonMergePatchModel {
  /**
   * Waiting list status
   * @maxLength 30
   */
  status?: WaitingListWaitingListSubmitJsonMergePatchModelStatus;
  /** Send the welcome email to the created user (used when status is approved) */
  emailNotification?: boolean;
}

/**
 * User role, front user role accepted
 * @maxLength 50
 * @nullable
 */
export type WaitingListWaitingListWriteModelRole = typeof WaitingListWaitingListWriteModelRole[keyof typeof WaitingListWaitingListWriteModelRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WaitingListWaitingListWriteModelRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
} as const;

export interface WaitingListWaitingListWriteModel {
  /**
   * Company name
   * @maxLength 100
   * @nullable
   */
  companyName?: string | null;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @nullable
   */
  companyUniqueCode?: string | null;
  /**
   * Company address line 1
   * @maxLength 255
   * @nullable
   */
  addressLine1?: string | null;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @maxLength 20
   * @nullable
   */
  zipcode?: string | null;
  /**
   * Company city
   * @maxLength 100
   * @nullable
   */
  city?: string | null;
  /**
   * Company country
   * @nullable
   */
  country?: string | null;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  /**
   * Responsible linked to the company
   * @nullable
   */
  responsible?: string | null;
  /**
   * Company typology
   * @nullable
   */
  typology?: string | null;
  /**
   * Coefficient used to calculate points (depending conversion type)
   * @minimum 0
   * @nullable
   */
  pointCoeff?: number | null;
  /**
   * User email
   * @maxLength 255
   * @nullable
   */
  email?: string | null;
  /**
   * User firstname
   * @maxLength 50
   * @nullable
   */
  firstname?: string | null;
  /**
   * User lastname
   * @maxLength 50
   * @nullable
   */
  lastname?: string | null;
  /**
   * User unique code
   * @maxLength 50
   * @nullable
   */
  userUniqueCode?: string | null;
  /**
   * User role, front user role accepted
   * @maxLength 50
   * @nullable
   */
  role?: WaitingListWaitingListWriteModelRole;
  /**
   * Comment about the company in waiting list
   * @nullable
   */
  comment?: string | null;
}

/**
 * User role, front user role accepted
 * @maxLength 50
 * @nullable
 */
export type WaitingListWaitingListWriteJsonMergePatchModelRole = typeof WaitingListWaitingListWriteJsonMergePatchModelRole[keyof typeof WaitingListWaitingListWriteJsonMergePatchModelRole] | null;


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WaitingListWaitingListWriteJsonMergePatchModelRole = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
} as const;

export interface WaitingListWaitingListWriteJsonMergePatchModel {
  /**
   * Company name
   * @maxLength 100
   * @nullable
   */
  companyName?: string | null;
  /**
   * Company unique code (SIREN or TVA or whatever)
   * @maxLength 50
   * @nullable
   */
  companyUniqueCode?: string | null;
  /**
   * Company address line 1
   * @maxLength 255
   * @nullable
   */
  addressLine1?: string | null;
  /**
   * Company address line 2
   * @maxLength 255
   * @nullable
   */
  addressLine2?: string | null;
  /**
   * Company address line 3
   * @maxLength 255
   * @nullable
   */
  addressLine3?: string | null;
  /**
   * Company zipcode
   * @maxLength 20
   * @nullable
   */
  zipcode?: string | null;
  /**
   * Company city
   * @maxLength 100
   * @nullable
   */
  city?: string | null;
  /**
   * Company country
   * @nullable
   */
  country?: string | null;
  /**
   * Company SIREN
   * @maxLength 9
   * @nullable
   */
  siren?: string | null;
  /**
   * Company TVA
   * @maxLength 20
   * @nullable
   */
  tva?: string | null;
  /**
   * Responsible linked to the company
   * @nullable
   */
  responsible?: string | null;
  /**
   * Company typology
   * @nullable
   */
  typology?: string | null;
  /**
   * Coefficient used to calculate points (depending conversion type)
   * @minimum 0
   * @nullable
   */
  pointCoeff?: number | null;
  /**
   * User email
   * @maxLength 255
   * @nullable
   */
  email?: string | null;
  /**
   * User firstname
   * @maxLength 50
   * @nullable
   */
  firstname?: string | null;
  /**
   * User lastname
   * @maxLength 50
   * @nullable
   */
  lastname?: string | null;
  /**
   * User unique code
   * @maxLength 50
   * @nullable
   */
  userUniqueCode?: string | null;
  /**
   * User role, front user role accepted
   * @maxLength 50
   * @nullable
   */
  role?: WaitingListWaitingListWriteJsonMergePatchModelRole;
  /**
   * Comment about the company in waiting list
   * @nullable
   */
  comment?: string | null;
}

/**
 * Retrieve a list of widgets and their definitions
 */
export interface WidgetWidgetReadModel {
  /** WidgetConfig ID */
  readonly id: number;
  /**
   * Widget label
   * @maxLength 50
   */
  label: string;
  /**
   * Widget unique key
   * @maxLength 50
   */
  key: string;
  itemDefinitions?: WidgetItemDefinitionWidgetReadModel[];
}

export interface WidgetWidgetWriteModel {
  /**
   * Widget label
   * @maxLength 50
   */
  label: string;
  /**
   * Widget unique key
   * @maxLength 50
   */
  key: string;
  itemDefinitions?: WidgetItemDefinitionWidgetWriteModel[];
}

export interface WidgetWidgetWorkspaceReadModel {
  /** WidgetConfig ID */
  readonly id: number;
  /**
   * Widget label
   * @maxLength 50
   */
  label: string;
  /**
   * Widget unique key
   * @maxLength 50
   */
  key: string;
}

export interface WidgetItemConfigurationWidgetConfigReadModel {
  /** Unique identifier for the widget item configuration */
  readonly id: number;
  /**
   * Slide position (1 = default flat display, 2-3 = slider)
   * @minimum 1
   * @maximum 3
   */
  slideIndex: number;
  /**
   * Derived key: itemKey for slide 1, itemKey.1 for slide 2, itemKey.2 for slide 3
   * @nullable
   */
  computedKey?: string | null;
  /**
   * Value of the configuration field (media IRI for media items)
   * @nullable
   */
  configValue?: string | null;
  widgetItemDefinition: WidgetItemDefinitionWidgetConfigReadModel;
}

export interface WidgetItemConfigurationWidgetConfigUpdateJsonMergePatchModel {
  /**
   * Slide position (1 = default flat display, 2-3 = slider)
   * @minimum 1
   * @maximum 3
   */
  slideIndex?: number;
  /**
   * Value of the configuration field (media IRI for media items)
   * @nullable
   */
  configValue?: string | null;
  /**
   * Media IRI for the widget item configuration
   * @nullable
   */
  media?: string | null;
}

export interface WidgetItemConfigurationWidgetWorkspacePatchJsonMergePatchModel {
  /**
   * Value of the configuration field (media IRI for media items)
   * @nullable
   */
  configValue?: string | null;
  /**
   * Media IRI for the widget item configuration
   * @nullable
   */
  media?: string | null;
  /** Widget item definition IRI for the configuration */
  widgetItemDefinition?: string;
}

export interface WidgetItemConfigurationWidgetWorkspaceReadModel {
  /** Unique identifier for the widget item configuration */
  readonly id: number;
  /**
   * Slide position (1 = default flat display, 2-3 = slider)
   * @minimum 1
   * @maximum 3
   */
  slideIndex: number;
  /**
   * Derived key: itemKey for slide 1, itemKey.1 for slide 2, itemKey.2 for slide 3
   * @nullable
   */
  computedKey?: string | null;
  /**
   * Value of the configuration field (media IRI for media items)
   * @nullable
   */
  configValue?: string | null;
  widgetItemDefinition: WidgetItemDefinitionWidgetWorkspaceReadModel;
}

/**
 * Data type of the configuration field
 * @maxLength 20
 */
export type WidgetItemDefinitionWidgetReadModelItemType = typeof WidgetItemDefinitionWidgetReadModelItemType[keyof typeof WidgetItemDefinitionWidgetReadModelItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WidgetItemDefinitionWidgetReadModelItemType = {
  string: 'string',
  text: 'text',
  media: 'media',
  url: 'url',
  hsl_color: 'hsl_color',
  select: 'select',
} as const;

export interface WidgetItemDefinitionWidgetReadModel {
  /** Item definition unique identifier */
  readonly id?: number;
  /**
   * Configuration field key
   * @maxLength 100
   */
  itemKey: string;
  /**
   * Data type of the configuration field
   * @maxLength 20
   */
  itemType: WidgetItemDefinitionWidgetReadModelItemType;
  /** Is this field required in the configuration form */
  isRequired: boolean;
  /**
   * Default value for this field
   * @nullable
   */
  defaultValue?: string | null;
  /**
   * Maximum length for string fields
   * @maximum 255
   * @nullable
   */
  maxLength?: number | null;
  /**
   * Allowed values, required for "select" items
   * @nullable
   */
  options?: string[] | null;
  /**
   * Label for the configuration field
   * @maxLength 255
   */
  itemLabel: string;
  /**
   * Description of the configuration field
   * @maxLength 255
   * @nullable
   */
  itemDescription?: string | null;
  /**
   * Placeholder text for the input field
   * @maxLength 50
   * @nullable
   */
  itemPlaceholder?: string | null;
}

/**
 * Data type of the configuration field
 * @maxLength 20
 */
export type WidgetItemDefinitionWidgetWriteModelItemType = typeof WidgetItemDefinitionWidgetWriteModelItemType[keyof typeof WidgetItemDefinitionWidgetWriteModelItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WidgetItemDefinitionWidgetWriteModelItemType = {
  string: 'string',
  text: 'text',
  media: 'media',
  url: 'url',
  hsl_color: 'hsl_color',
  select: 'select',
} as const;

export interface WidgetItemDefinitionWidgetWriteModel {
  /**
   * Configuration field key
   * @maxLength 100
   */
  itemKey: string;
  /**
   * Data type of the configuration field
   * @maxLength 20
   */
  itemType: WidgetItemDefinitionWidgetWriteModelItemType;
  /** Is this field required in the configuration form */
  isRequired: boolean;
  /**
   * Default value for this field
   * @nullable
   */
  defaultValue?: string | null;
  /**
   * Maximum length for string fields
   * @maximum 255
   * @nullable
   */
  maxLength?: number | null;
  /**
   * Allowed values, required for "select" items
   * @nullable
   */
  options?: string[] | null;
  /**
   * Label for the configuration field
   * @maxLength 255
   */
  itemLabel: string;
  /**
   * Description of the configuration field
   * @maxLength 255
   * @nullable
   */
  itemDescription?: string | null;
  /**
   * Placeholder text for the input field
   * @maxLength 50
   * @nullable
   */
  itemPlaceholder?: string | null;
}

export interface WidgetItemDefinitionWidgetConfigReadModel {
  /** Item definition unique identifier */
  readonly id?: number;
  /**
   * Configuration field key
   * @maxLength 100
   */
  itemKey: string;
}

/**
 * Data type of the configuration field
 * @maxLength 20
 */
export type WidgetItemDefinitionWidgetWorkspaceReadModelItemType = typeof WidgetItemDefinitionWidgetWorkspaceReadModelItemType[keyof typeof WidgetItemDefinitionWidgetWorkspaceReadModelItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WidgetItemDefinitionWidgetWorkspaceReadModelItemType = {
  string: 'string',
  text: 'text',
  media: 'media',
  url: 'url',
  hsl_color: 'hsl_color',
  select: 'select',
} as const;

export interface WidgetItemDefinitionWidgetWorkspaceReadModel {
  /**
   * Configuration field key
   * @maxLength 100
   */
  itemKey: string;
  /**
   * Data type of the configuration field
   * @maxLength 20
   */
  itemType: WidgetItemDefinitionWidgetWorkspaceReadModelItemType;
}

export interface WidgetWorkspaceWidgetWorkspacePatchJsonMergePatchModel {
  /**
   * Display name for this widget instance in the workspace
   * @maxLength 100
   */
  name?: string;
  /** Whether the widget is active for this workspace */
  isActive?: boolean;
  /**
   * Display start date. Null = displayed as soon as the widget is saved.
   * @nullable
   */
  startAt?: string | null;
  /**
   * Display end date. Null = displayed indefinitely.
   * @nullable
   */
  endAt?: string | null;
  /**
   * Display order of the block (ascending). Omitted on creation = appended after the existing blocks.
   * @minimum 0
   */
  sortOrder?: number;
  /**
   * PATCH only — slide to update (1-3). Must be paired with patchConfigurations.
   * @nullable
   */
  slideIndex?: number | null;
  patchConfigurations?: WidgetItemConfigurationWidgetWorkspacePatchJsonMergePatchModel[];
}

export interface WidgetWorkspaceWidgetWorkspaceReadModel {
  readonly id?: number;
  /**
   * Display name for this widget instance in the workspace
   * @maxLength 100
   */
  name: string;
  /** Whether the widget is active for this workspace */
  isActive: boolean;
  /**
   * Display start date. Null = displayed as soon as the widget is saved.
   * @nullable
   */
  startAt?: string | null;
  /**
   * Display end date. Null = displayed indefinitely.
   * @nullable
   */
  endAt?: string | null;
  /**
   * Display order of the block (ascending). Omitted on creation = appended after the existing blocks.
   * @minimum 0
   */
  sortOrder?: number;
  widget: WidgetWidgetWorkspaceReadModel;
  widgetItemConfigurations?: WidgetItemConfigurationWidgetWorkspaceReadModel[];
}

export interface WidgetWorkspaceWidgetWorkspaceWriteModel {
  /**
   * Display name for this widget instance in the workspace
   * @maxLength 100
   */
  name: string;
  /** Whether the widget is active for this workspace */
  isActive: boolean;
  /**
   * Display start date. Null = displayed as soon as the widget is saved.
   * @nullable
   */
  startAt?: string | null;
  /**
   * Display end date. Null = displayed indefinitely.
   * @nullable
   */
  endAt?: string | null;
  /**
   * Display order of the block (ascending). Omitted on creation = appended after the existing blocks.
   * @minimum 0
   */
  sortOrder?: number;
  /** The widget associated with this workspace */
  widget: string;
}

/**
 * Workspace status
 * @maxLength 20
 */
export type WorkspaceMeReadModelStatus = typeof WorkspaceMeReadModelStatus[keyof typeof WorkspaceMeReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceMeReadModelStatus = {
  active: 'active',
  draft: 'draft',
  misconfigured: 'misconfigured',
} as const;

export interface WorkspaceMeReadModel {
  /** Workspace ID */
  readonly id: number;
  /**
   * Workspace name
   * @maxLength 50
   */
  name: string;
  /**
   * Workspace status
   * @maxLength 20
   */
  status?: WorkspaceMeReadModelStatus;
}

export type WorkspaceWorkspaceInviteModelInvitedUserWorkspace = UserWorkspaceWorkspaceInviteModel | null;

export interface WorkspaceWorkspaceInviteModel {
  /**
   * Workspace name
   * @maxLength 50
   */
  name: string;
  invitedUserWorkspace: WorkspaceWorkspaceInviteModelInvitedUserWorkspace;
  /**
   * Workspace domain
   * @maxLength 255
   * @pattern ^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$
   */
  domain: string;
}

export interface WorkspaceWorkspaceMaintenanceWriteJsonMergePatchModel {
  isMaintenance?: boolean;
}

export type WorkspaceWorkspaceReadAdminWorkspaceReadModelCurrentLogicWorkspace = LogicWorkspaceWorkspaceReadAdminWorkspaceReadModel | null;

/**
 * Workspace status
 * @maxLength 20
 */
export type WorkspaceWorkspaceReadAdminWorkspaceReadModelStatus = typeof WorkspaceWorkspaceReadAdminWorkspaceReadModelStatus[keyof typeof WorkspaceWorkspaceReadAdminWorkspaceReadModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceWorkspaceReadAdminWorkspaceReadModelStatus = {
  active: 'active',
  draft: 'draft',
  misconfigured: 'misconfigured',
} as const;

export interface WorkspaceWorkspaceReadAdminWorkspaceReadModel {
  /** Workspace ID */
  readonly id: number;
  /**
   * Workspace name
   * @maxLength 50
   */
  name: string;
  currentLogicWorkspace?: WorkspaceWorkspaceReadAdminWorkspaceReadModelCurrentLogicWorkspace;
  isMaintenance?: boolean;
  /**
   * Workspace domain
   * @maxLength 255
   * @pattern ^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$
   */
  domain: string;
  /** Workspace preprod domain, used by the front-user preprod link */
  preprodDomain?: string;
  logics?: LogicWorkspaceWorkspaceReadAdminWorkspaceReadModel[];
  /**
   * Default email sender, used for sending emails
   * @nullable
   */
  defaultEmailSender?: string | null;
  /**
   * Default help recipient, the email address where the help requests are sent
   * @nullable
   */
  defaultHelpRecipient?: string | null;
  /**
   * Workspace status
   * @maxLength 20
   */
  status?: WorkspaceWorkspaceReadAdminWorkspaceReadModelStatus;
  typologies?: TypologyWorkspaceReadAdminWorkspaceReadModel[];
  activeShops: ShopWorkspaceReadAdminWorkspaceReadModel[];
  /** Number of active games */
  activeGamesCount: number;
}

export type WorkspaceWorkspaceWriteModelCurrentLogicWorkspace = LogicWorkspaceWorkspaceWriteModel | null;

/**
 * Workspace status
 * @maxLength 20
 */
export type WorkspaceWorkspaceWriteModelStatus = typeof WorkspaceWorkspaceWriteModelStatus[keyof typeof WorkspaceWorkspaceWriteModelStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const WorkspaceWorkspaceWriteModelStatus = {
  active: 'active',
  draft: 'draft',
  misconfigured: 'misconfigured',
} as const;

export interface WorkspaceWorkspaceWriteModel {
  /**
   * Workspace name
   * @maxLength 50
   */
  name: string;
  workspaceConfigs?: WorkspaceConfigWorkspaceWriteModel[];
  currentLogicWorkspace?: WorkspaceWorkspaceWriteModelCurrentLogicWorkspace;
  /**
   * Workspace domain
   * @maxLength 255
   * @pattern ^((?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9][a-z0-9-]{0,61}[a-z0-9])$
   */
  domain: string;
  /**
   * Default email sender, used for sending emails
   * @nullable
   */
  defaultEmailSender?: string | null;
  /**
   * Default help recipient, the email address where the help requests are sent
   * @nullable
   */
  defaultHelpRecipient?: string | null;
  /**
   * Workspace status
   * @maxLength 20
   */
  status?: WorkspaceWorkspaceWriteModelStatus;
  typologies?: TypologyWorkspaceWriteModel[];
}

/**
 * @deprecated
 */
export interface WorkspaceWorkspaceConfigWriteJsonMergePatchModel {
  workspaceConfigs?: WorkspaceConfigWorkspaceConfigWriteModel[];
}

export interface WorkspaceConfigModel {
  /** WorkspaceConfig ID */
  readonly id: number;
  /** Workspace IRI */
  workspace: string;
  /**
   * WorkspaceConfig value
   * @maxLength 255
   */
  value: string;
  createdAt?: string;
  updatedAt?: string;
  /**
   * Media IRI linked to this config
   * @nullable
   */
  media?: string | null;
  /** Config IRI */
  config: string;
  created_at?: unknown;
  updated_at?: unknown;
}

export interface WorkspaceConfigWorkspaceWriteModel {
  /**
   * WorkspaceConfig value
   * @maxLength 255
   */
  value: string;
  /**
   * Media IRI linked to this config
   * @nullable
   */
  media?: string | null;
  /** Config IRI */
  config: string;
}

export interface WorkspaceConfigWorkspaceConfigReadModel {
  /** WorkspaceConfig ID */
  readonly id: number;
  /**
   * WorkspaceConfig value
   * @maxLength 255
   */
  value: string;
  /**
   * Media IRI linked to this config
   * @nullable
   */
  media?: string | null;
  config: ConfigWorkspaceConfigReadModel;
}

export interface WorkspaceConfigWorkspaceConfigUpdateJsonMergePatchModel {
  /**
   * WorkspaceConfig value
   * @maxLength 255
   */
  value?: string;
  /**
   * Media IRI linked to this config
   * @nullable
   */
  media?: string | null;
}

export interface WorkspaceConfigWorkspaceConfigWriteModel {
  /**
   * WorkspaceConfig value
   * @maxLength 255
   */
  value: string;
  /**
   * Media IRI linked to this config
   * @nullable
   */
  media?: string | null;
  /** Config IRI */
  config: string;
}

export type WorkspaceConfigGroupedWorkspaceConfigModelGroupedConfigs = { [key: string]: unknown };

export interface WorkspaceConfigGroupedWorkspaceConfigModel {
  groupedConfigs?: WorkspaceConfigGroupedWorkspaceConfigModelGroupedConfigs;
}

/**
 * Live DNS and email configurations of a workspace, along with the workspace status they lead to
 */
export interface WorkspaceConfigurationWorkspaceConfigurationReadModel {
  /** Workspace status, aligned with the configurations when the workspace is published */
  status: string;
  dnsConfiguration: WorkspaceDnsConfigurationWorkspaceConfigurationReadModel;
  emailConfiguration: WorkspaceEmailConfigurationWorkspaceConfigurationReadModel;
}

export interface WorkspaceDnsConfigurationWorkspaceConfigurationReadModel {
  /** Workspace domain */
  domain: string;
  /** If the domain is resolving to the workspace website and verified */
  isValid: boolean;
  records: DnsRecordWorkspaceConfigurationReadModel[];
}

export interface WorkspaceEmailConfigurationWorkspaceConfigurationReadModel {
  /** Domain authenticated on Brevo to send emails */
  domain: string;
  /** If the domain is authenticated, all records are valid and the sender is active */
  isValid: boolean;
  /** If Brevo has authenticated the domain */
  isDomainAuthenticated: boolean;
  records: DnsRecordWorkspaceConfigurationReadModel[];
  /**
   * Default email sender of the workspace, null if not set
   * @nullable
   */
  senderEmail: string | null;
  /** If the default sender is active on Brevo */
  isSenderActive: boolean;
}

export interface ForgotPasswordResetModel {
  plainPassword: string;
}

export type ForgotPasswordRequestModelEmail = string | number;

export interface ForgotPasswordRequestModel {
  email: ForgotPasswordRequestModelEmail;
}

/**
 * @nullable
 */
export type ForgotPasswordValidateModel = { [key: string]: unknown } | null;

export interface ForgotPasswordRequestV2Model {
  email: string;
}

export type ForgotPasswordValidateV2ModelUser = {
  id: number;
  email: string;
};

export interface ForgotPasswordValidateV2Model {
  user: ForgotPasswordValidateV2ModelUser;
  expired: boolean;
}

/**
 * Bad Request
 */
export type N400Response = HttpErrorModel;

/**
 * Unauthorized
 */
export type N401Response = HttpErrorModel;

/**
 * Forbidden
 */
export type N403Response = HttpErrorModel;

/**
 * Not Found
 */
export type N404Response = HttpErrorModel;

/**
 * Unprocessable Entity
 */
export type N422Response = UnprocessableEntityModel;

export type AppIDParams = string;

export type LoginCheckPostBody = {
  /** */
  email: string;
  /** */
  password: string;
};

export type ApiBoostersGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
};

export type AdminChangelogsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
/**
 * Search in title, description
 */
search?: string;
'createdAt[before]'?: string;
'createdAt[strictly_before]'?: string;
'createdAt[after]'?: string;
'createdAt[strictly_after]'?: string;
title?: string;
description?: string;
tag?: string;
'tag[]'?: string[];
target?: string;
'target[]'?: string[];
'order[title]'?: AdminChangelogsOrderTitle;
'order[tag]'?: AdminChangelogsOrderTag;
'order[description]'?: AdminChangelogsOrderDescription;
'order[target]'?: AdminChangelogsOrderTarget;
'order[createdAt]'?: AdminChangelogsOrderCreatedAt;
};

export type AdminChangelogsOrderTitle = typeof AdminChangelogsOrderTitle[keyof typeof AdminChangelogsOrderTitle];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChangelogsOrderTitle = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type AdminChangelogsOrderTag = typeof AdminChangelogsOrderTag[keyof typeof AdminChangelogsOrderTag];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChangelogsOrderTag = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type AdminChangelogsOrderDescription = typeof AdminChangelogsOrderDescription[keyof typeof AdminChangelogsOrderDescription];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChangelogsOrderDescription = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type AdminChangelogsOrderTarget = typeof AdminChangelogsOrderTarget[keyof typeof AdminChangelogsOrderTarget];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChangelogsOrderTarget = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type AdminChangelogsOrderCreatedAt = typeof AdminChangelogsOrderCreatedAt[keyof typeof AdminChangelogsOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminChangelogsOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type AdminChangelogs200AllOf = {
  data?: ChangelogChangelogReadModel[];
};

export type AdminChangelogs200 = PaginatedResponseModel & AdminChangelogs200AllOf;

export type ApiChangelogsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
/**
 * Search in title, description
 */
search?: string;
'createdAt[before]'?: string;
'createdAt[strictly_before]'?: string;
'createdAt[after]'?: string;
'createdAt[strictly_after]'?: string;
title?: string;
description?: string;
tag?: string;
'tag[]'?: string[];
/**
 * Retourne uniquement les changelogs plus récents que la dernière connexion
 */
onlyNew?: string;
};

export type ApiChangelogsGetCollection200AllOf = {
  data?: ChangelogChangelogReadModel[];
};

export type ApiChangelogsGetCollection200 = PaginatedResponseModel & ApiChangelogsGetCollection200AllOf;

export type ApiAdmincompaniesGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
name?: string;
uniqueCode?: string;
siren?: string;
tva?: string;
addressLine1?: string;
city?: string;
zipcode?: string;
'country.alpha3'?: string;
'country.alpha3[]'?: string[];
comment?: string;
/**
 * Search in concatenated fields: companyResponsibles.responsible.user.firstname   companyResponsibles.responsible.user.lastname
 */
'responsible.user.fullname'?: string;
/**
 * Search in name, uniqueCode, addressLine1, zipcode, city, country.alpha3, companyResponsibles.responsible.uniqueCode, typology.name
 */
search?: string;
'lastStepReached[]'?: string[];
'typology[]'?: string[];
'status[]'?: ApiAdmincompaniesGetCollectionStatusItem[];
'order[name]'?: ApiAdmincompaniesGetCollectionOrderName;
'order[createdAt]'?: ApiAdmincompaniesGetCollectionOrderCreatedAt;
'order[pointCoeff]'?: ApiAdmincompaniesGetCollectionOrderPointCoeff;
'order[typology.name]'?: ApiAdmincompaniesGetCollectionOrderTypologyName;
'order[acquiredPoints]'?: ApiAdmincompaniesGetCollectionOrderAcquiredPoints;
'order[caAmount]'?: ApiAdmincompaniesGetCollectionOrderCaAmount;
'order[balance]'?: ApiAdmincompaniesGetCollectionOrderBalance;
'order[commercial]'?: ApiAdmincompaniesGetCollectionOrderCommercial;
'order[lastStepReached]'?: ApiAdmincompaniesGetCollectionOrderLastStepReached;
'order[registeredAt]'?: ApiAdmincompaniesGetCollectionOrderRegisteredAt;
'sales[]'?: string[];
/**
 * Filter companies with balance greater than or equal to this value
 */
'balance[gte]'?: string;
/**
 * Filter companies with balance less than or equal to this value
 */
'balance[lte]'?: string;
/**
 * Filter companies with acquired points greater than or equal to this value
 */
'acquiredPoints[gte]'?: string;
/**
 * Filter companies with acquired points less than or equal to this value
 */
'acquiredPoints[lte]'?: string;
/**
 * Filter companies registered after this date (format: Y-m-d or ISO 8601)
 */
'registeredAt[after]'?: string;
/**
 * Filter companies registered before this date (format: Y-m-d or ISO 8601)
 */
'registeredAt[before]'?: string;
/**
 * Filter companies with coefficient greater than or equal to this value
 */
'pointCoeff[gte]'?: string;
/**
 * Filter companies with coefficient less than or equal to this value
 */
'pointCoeff[lte]'?: string;
};

export type ApiAdmincompaniesGetCollectionStatusItem = typeof ApiAdmincompaniesGetCollectionStatusItem[keyof typeof ApiAdmincompaniesGetCollectionStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionStatusItem = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type ApiAdmincompaniesGetCollectionOrderName = typeof ApiAdmincompaniesGetCollectionOrderName[keyof typeof ApiAdmincompaniesGetCollectionOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderCreatedAt = typeof ApiAdmincompaniesGetCollectionOrderCreatedAt[keyof typeof ApiAdmincompaniesGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderPointCoeff = typeof ApiAdmincompaniesGetCollectionOrderPointCoeff[keyof typeof ApiAdmincompaniesGetCollectionOrderPointCoeff];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderPointCoeff = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderTypologyName = typeof ApiAdmincompaniesGetCollectionOrderTypologyName[keyof typeof ApiAdmincompaniesGetCollectionOrderTypologyName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderTypologyName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderAcquiredPoints = typeof ApiAdmincompaniesGetCollectionOrderAcquiredPoints[keyof typeof ApiAdmincompaniesGetCollectionOrderAcquiredPoints];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderAcquiredPoints = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderCaAmount = typeof ApiAdmincompaniesGetCollectionOrderCaAmount[keyof typeof ApiAdmincompaniesGetCollectionOrderCaAmount];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderCaAmount = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderBalance = typeof ApiAdmincompaniesGetCollectionOrderBalance[keyof typeof ApiAdmincompaniesGetCollectionOrderBalance];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderBalance = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderCommercial = typeof ApiAdmincompaniesGetCollectionOrderCommercial[keyof typeof ApiAdmincompaniesGetCollectionOrderCommercial];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderCommercial = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderLastStepReached = typeof ApiAdmincompaniesGetCollectionOrderLastStepReached[keyof typeof ApiAdmincompaniesGetCollectionOrderLastStepReached];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderLastStepReached = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollectionOrderRegisteredAt = typeof ApiAdmincompaniesGetCollectionOrderRegisteredAt[keyof typeof ApiAdmincompaniesGetCollectionOrderRegisteredAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmincompaniesGetCollectionOrderRegisteredAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmincompaniesGetCollection200AllOf = {
  data?: CompanyCompanyCollectionReadModel[];
};

export type ApiAdmincompaniesGetCollection200 = PaginatedResponseModel & ApiAdmincompaniesGetCollection200AllOf;

export type ApiAdminconfigsGetCollectionParams = {
type?: string;
'type[]'?: string[];
key?: string;
'key[]'?: string[];
};

export type ApiCountriesGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
};

export type ApiCountriesGetCollection200AllOf = {
  data?: CountryCountryReadModel[];
};

export type ApiCountriesGetCollection200 = PaginatedResponseModel & ApiCountriesGetCollection200AllOf;

export type ApiAdminemailsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
subject?: string;
to?: string;
status?: string;
'status[]'?: string[];
'userWorkspace.uniqueCode'?: string;
'userWorkspace.uniqueCode[]'?: string[];
'userWorkspace.company.uniqueCode'?: string;
'userWorkspace.company.uniqueCode[]'?: string[];
'userWorkspace.company.name'?: string;
'sentAt[before]'?: string;
'sentAt[strictly_before]'?: string;
'sentAt[after]'?: string;
'sentAt[strictly_after]'?: string;
'statusUpdatedAt[before]'?: string;
'statusUpdatedAt[strictly_before]'?: string;
'statusUpdatedAt[after]'?: string;
'statusUpdatedAt[strictly_after]'?: string;
'order[sentAt]'?: ApiAdminemailsGetCollectionOrderSentAt;
'order[statusUpdatedAt]'?: ApiAdminemailsGetCollectionOrderStatusUpdatedAt;
'order[status]'?: ApiAdminemailsGetCollectionOrderStatus;
/**
 * Search in concatenated fields: userWorkspace.user.firstname   userWorkspace.user.lastname
 */
'user.fullname'?: string;
};

export type ApiAdminemailsGetCollectionOrderSentAt = typeof ApiAdminemailsGetCollectionOrderSentAt[keyof typeof ApiAdminemailsGetCollectionOrderSentAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminemailsGetCollectionOrderSentAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminemailsGetCollectionOrderStatusUpdatedAt = typeof ApiAdminemailsGetCollectionOrderStatusUpdatedAt[keyof typeof ApiAdminemailsGetCollectionOrderStatusUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminemailsGetCollectionOrderStatusUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminemailsGetCollectionOrderStatus = typeof ApiAdminemailsGetCollectionOrderStatus[keyof typeof ApiAdminemailsGetCollectionOrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminemailsGetCollectionOrderStatus = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminemailsGetCollection200AllOf = {
  data?: EmailEmailReadModel[];
};

export type ApiAdminemailsGetCollection200 = PaginatedResponseModel & ApiAdminemailsGetCollection200AllOf;

export type ApiGamesGetCollectionParams = {
'order[openingDate]'?: ApiGamesGetCollectionOrderOpeningDate;
'order[closingDate]'?: ApiGamesGetCollectionOrderClosingDate;
'order[createdAt]'?: ApiGamesGetCollectionOrderCreatedAt;
};

export type ApiGamesGetCollectionOrderOpeningDate = typeof ApiGamesGetCollectionOrderOpeningDate[keyof typeof ApiGamesGetCollectionOrderOpeningDate];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiGamesGetCollectionOrderOpeningDate = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiGamesGetCollectionOrderClosingDate = typeof ApiGamesGetCollectionOrderClosingDate[keyof typeof ApiGamesGetCollectionOrderClosingDate];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiGamesGetCollectionOrderClosingDate = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiGamesGetCollectionOrderCreatedAt = typeof ApiGamesGetCollectionOrderCreatedAt[keyof typeof ApiGamesGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiGamesGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmininsightscompaniesGetCollectionParams = {
'status[]'?: ApiAdmininsightscompaniesGetCollectionStatusItem[];
'typology[]'?: string[];
'sales[]'?: string[];
from?: string;
to?: string;
};

export type ApiAdmininsightscompaniesGetCollectionStatusItem = typeof ApiAdmininsightscompaniesGetCollectionStatusItem[keyof typeof ApiAdmininsightscompaniesGetCollectionStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmininsightscompaniesGetCollectionStatusItem = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type ApiAdmininsightsordersGetCollectionParams = {
'status[]'?: ApiAdmininsightsordersGetCollectionStatusItem[];
'typology[]'?: string[];
'sales[]'?: string[];
from?: string;
to?: string;
};

export type ApiAdmininsightsordersGetCollectionStatusItem = typeof ApiAdmininsightsordersGetCollectionStatusItem[keyof typeof ApiAdmininsightsordersGetCollectionStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmininsightsordersGetCollectionStatusItem = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type ApiAdmininsightsperformancesGetCollectionParams = {
'status[]'?: ApiAdmininsightsperformancesGetCollectionStatusItem[];
'typology[]'?: string[];
'sales[]'?: string[];
from?: string;
to?: string;
};

export type ApiAdmininsightsperformancesGetCollectionStatusItem = typeof ApiAdmininsightsperformancesGetCollectionStatusItem[keyof typeof ApiAdmininsightsperformancesGetCollectionStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmininsightsperformancesGetCollectionStatusItem = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type ApiAdmininsightspointsGetCollectionParams = {
'status[]'?: ApiAdmininsightspointsGetCollectionStatusItem[];
'typology[]'?: string[];
'sales[]'?: string[];
from?: string;
to?: string;
};

export type ApiAdmininsightspointsGetCollectionStatusItem = typeof ApiAdmininsightspointsGetCollectionStatusItem[keyof typeof ApiAdmininsightspointsGetCollectionStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmininsightspointsGetCollectionStatusItem = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type ApiAdmininsightsusersGetCollectionParams = {
'status[]'?: ApiAdmininsightsusersGetCollectionStatusItem[];
'typology[]'?: string[];
'sales[]'?: string[];
from?: string;
to?: string;
/**
 * Filter users by role
 */
'maxRole[]'?: ApiAdmininsightsusersGetCollectionMaxRoleItem[];
};

export type ApiAdmininsightsusersGetCollectionStatusItem = typeof ApiAdmininsightsusersGetCollectionStatusItem[keyof typeof ApiAdmininsightsusersGetCollectionStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmininsightsusersGetCollectionStatusItem = {
  companystatusunregistered: 'company.status.unregistered',
  companystatusregistered: 'company.status.registered',
  companystatusblocked: 'company.status.blocked',
  companystatusinactive: 'company.status.inactive',
} as const;

export type ApiAdmininsightsusersGetCollectionMaxRoleItem = typeof ApiAdmininsightsusersGetCollectionMaxRoleItem[keyof typeof ApiAdmininsightsusersGetCollectionMaxRoleItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmininsightsusersGetCollectionMaxRoleItem = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export type MeInsightsParams = {
from?: string;
to?: string;
/**
 * Filter by reference unique codes
 */
'referenceUniqueCode[]'?: string[];
};

export type AdminLocalesParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
country?: string;
'country[]'?: string[];
label?: string;
content?: string;
/**
 * Search in label, content, localeCustoms.content
 */
search?: string;
isCustom?: boolean;
};

export type AdminLocales200AllOf = {
  data?: LocaleLocaleAdminReadModel[];
};

export type AdminLocales200 = PaginatedResponseModel & AdminLocales200AllOf;

export type ApiLocalesGetCollectionParams = {
country?: string;
'country[]'?: string[];
};

export type ApiAdminlogicTypeStepHistoriesGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
'company.name'?: string;
'company.uniqueCode'?: string;
'logicTypeStep.name'?: string;
'order[company.name]'?: ApiAdminlogicTypeStepHistoriesGetCollectionOrderCompanyName;
'order[logicTypeStep.name]'?: ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepName;
'order[logicTypeStep.stepPoint]'?: ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepStepPoint;
'order[createdAt]'?: ApiAdminlogicTypeStepHistoriesGetCollectionOrderCreatedAt;
};

export type ApiAdminlogicTypeStepHistoriesGetCollectionOrderCompanyName = typeof ApiAdminlogicTypeStepHistoriesGetCollectionOrderCompanyName[keyof typeof ApiAdminlogicTypeStepHistoriesGetCollectionOrderCompanyName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminlogicTypeStepHistoriesGetCollectionOrderCompanyName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepName = typeof ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepName[keyof typeof ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepStepPoint = typeof ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepStepPoint[keyof typeof ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepStepPoint];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminlogicTypeStepHistoriesGetCollectionOrderLogicTypeStepStepPoint = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminlogicTypeStepHistoriesGetCollectionOrderCreatedAt = typeof ApiAdminlogicTypeStepHistoriesGetCollectionOrderCreatedAt[keyof typeof ApiAdminlogicTypeStepHistoriesGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminlogicTypeStepHistoriesGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminlogicTypeStepHistoriesGetCollection200AllOf = {
  data?: LogicTypeStepHistoryLogicTypeStepHistoryCollectionReadModel[];
};

export type ApiAdminlogicTypeStepHistoriesGetCollection200 = PaginatedResponseModel & ApiAdminlogicTypeStepHistoriesGetCollection200AllOf;

export type ApiAdmintargetsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
'company.name'?: string;
'company.uniqueCode'?: string;
'logicTypeTarget.reference'?: string;
'logicTypeTarget.reference[]'?: string[];
/**
 * Filter by achieved status (true = achieved, false = not achieved)
 */
achieved?: string;
'order[company.name]'?: ApiAdmintargetsGetCollectionOrderCompanyName;
'order[value]'?: ApiAdmintargetsGetCollectionOrderValue;
'order[targetValue]'?: ApiAdmintargetsGetCollectionOrderTargetValue;
'order[updatedAt]'?: ApiAdmintargetsGetCollectionOrderUpdatedAt;
'order[achievedPercentage]'?: ApiAdmintargetsGetCollectionOrderAchievedPercentage;
};

export type ApiAdmintargetsGetCollectionOrderCompanyName = typeof ApiAdmintargetsGetCollectionOrderCompanyName[keyof typeof ApiAdmintargetsGetCollectionOrderCompanyName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmintargetsGetCollectionOrderCompanyName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmintargetsGetCollectionOrderValue = typeof ApiAdmintargetsGetCollectionOrderValue[keyof typeof ApiAdmintargetsGetCollectionOrderValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmintargetsGetCollectionOrderValue = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmintargetsGetCollectionOrderTargetValue = typeof ApiAdmintargetsGetCollectionOrderTargetValue[keyof typeof ApiAdmintargetsGetCollectionOrderTargetValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmintargetsGetCollectionOrderTargetValue = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmintargetsGetCollectionOrderUpdatedAt = typeof ApiAdmintargetsGetCollectionOrderUpdatedAt[keyof typeof ApiAdmintargetsGetCollectionOrderUpdatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmintargetsGetCollectionOrderUpdatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmintargetsGetCollectionOrderAchievedPercentage = typeof ApiAdmintargetsGetCollectionOrderAchievedPercentage[keyof typeof ApiAdmintargetsGetCollectionOrderAchievedPercentage];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdmintargetsGetCollectionOrderAchievedPercentage = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdmintargetsGetCollection200AllOf = {
  data?: LogicTypeTargetStatusLogicTypeTargetStatusCollectionReadModel[];
};

export type ApiAdmintargetsGetCollection200 = PaginatedResponseModel & ApiAdmintargetsGetCollection200AllOf;

export type ApiAdminlogicsworkspacesGetCollectionParams = {
'order[createdAt]'?: ApiAdminlogicsworkspacesGetCollectionOrderCreatedAt;
'order[startAt]'?: ApiAdminlogicsworkspacesGetCollectionOrderStartAt;
'order[endAt]'?: ApiAdminlogicsworkspacesGetCollectionOrderEndAt;
};

export type ApiAdminlogicsworkspacesGetCollectionOrderCreatedAt = typeof ApiAdminlogicsworkspacesGetCollectionOrderCreatedAt[keyof typeof ApiAdminlogicsworkspacesGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminlogicsworkspacesGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminlogicsworkspacesGetCollectionOrderStartAt = typeof ApiAdminlogicsworkspacesGetCollectionOrderStartAt[keyof typeof ApiAdminlogicsworkspacesGetCollectionOrderStartAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminlogicsworkspacesGetCollectionOrderStartAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminlogicsworkspacesGetCollectionOrderEndAt = typeof ApiAdminlogicsworkspacesGetCollectionOrderEndAt[keyof typeof ApiAdminlogicsworkspacesGetCollectionOrderEndAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminlogicsworkspacesGetCollectionOrderEndAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiOrdersGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
'madeBy.uniqueCode'?: string;
'madeBy.user.email'?: string;
'company.uniqueCode'?: string;
'company.name'?: string;
status?: string;
'status[]'?: string[];
reference?: string;
'orderProducts.product.shop.displayName'?: string;
'orderProducts.product.name'?: string;
'orderProducts.product.id'?: number;
'orderProducts.product.id[]'?: number[];
'createdAt[before]'?: string;
'createdAt[strictly_before]'?: string;
'createdAt[after]'?: string;
'createdAt[strictly_after]'?: string;
'order[createdAt]'?: ApiOrdersGetCollectionOrderCreatedAt;
'order[point.amount]'?: ApiOrdersGetCollectionOrderPointAmount;
'order[status]'?: ApiOrdersGetCollectionOrderStatus;
'point.amount[between]'?: string;
'point.amount[gt]'?: string;
'point.amount[gte]'?: string;
'point.amount[lt]'?: string;
'point.amount[lte]'?: string;
/**
 * Search in concatenated fields: madeBy.user.firstname   madeBy.user.lastname
 */
'madeBy.user.fullname'?: string;
'productsCount[gte]'?: string;
'productsCount[gt]'?: string;
'productsCount[lte]'?: string;
'productsCount[lt]'?: string;
'productsCount[between]'?: string;
'order[productsCount]'?: ApiOrdersGetCollectionOrderProductsCount;
'order[orderProducts.product.shop.displayName]'?: ApiOrdersGetCollectionOrderOrderProductsProductShopDisplayName;
};

export type ApiOrdersGetCollectionOrderCreatedAt = typeof ApiOrdersGetCollectionOrderCreatedAt[keyof typeof ApiOrdersGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiOrdersGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiOrdersGetCollectionOrderPointAmount = typeof ApiOrdersGetCollectionOrderPointAmount[keyof typeof ApiOrdersGetCollectionOrderPointAmount];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiOrdersGetCollectionOrderPointAmount = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiOrdersGetCollectionOrderStatus = typeof ApiOrdersGetCollectionOrderStatus[keyof typeof ApiOrdersGetCollectionOrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiOrdersGetCollectionOrderStatus = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiOrdersGetCollectionOrderProductsCount = typeof ApiOrdersGetCollectionOrderProductsCount[keyof typeof ApiOrdersGetCollectionOrderProductsCount];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiOrdersGetCollectionOrderProductsCount = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiOrdersGetCollectionOrderOrderProductsProductShopDisplayName = typeof ApiOrdersGetCollectionOrderOrderProductsProductShopDisplayName[keyof typeof ApiOrdersGetCollectionOrderOrderProductsProductShopDisplayName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiOrdersGetCollectionOrderOrderProductsProductShopDisplayName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiOrdersGetCollection200AllOf = {
  data?: OrderOrderCollectionReadModel[];
};

export type ApiOrdersGetCollection200 = PaginatedResponseModel & ApiOrdersGetCollection200AllOf;

export type ApiAdminperformancesGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
'realizedByCompany.name'?: string;
'realizedByCompany.uniqueCode'?: string;
label?: string;
'logicTypeTarget.reference'?: string;
'logicTypeTarget.reference[]'?: string[];
referenceUniqueCode?: string;
'referenceUniqueCode[]'?: string[];
'addedByUserWorkspace.uniqueCode'?: string;
'realizedAt[before]'?: string;
'realizedAt[strictly_before]'?: string;
'realizedAt[after]'?: string;
'realizedAt[strictly_after]'?: string;
'createdAt[before]'?: string;
'createdAt[strictly_before]'?: string;
'createdAt[after]'?: string;
'createdAt[strictly_after]'?: string;
'referenceQuantity[between]'?: string;
'referenceQuantity[gt]'?: string;
'referenceQuantity[gte]'?: string;
'referenceQuantity[lt]'?: string;
'referenceQuantity[lte]'?: string;
'amount[gte]'?: string;
'amount[gt]'?: string;
'amount[lte]'?: string;
'amount[lt]'?: string;
'amount[between]'?: string;
/**
 * Search in concatenated fields: addedByUserWorkspace.user.firstname   addedByUserWorkspace.user.lastname
 */
'addedByUserWorkspace.user.fullname'?: string;
/**
 * Search in concatenated fields: realizedBy.user.firstname   realizedBy.user.lastname
 */
'realizedBy.user.fullname'?: string;
'order[id]'?: ApiAdminperformancesGetCollectionOrderId;
'order[realizedAt]'?: ApiAdminperformancesGetCollectionOrderRealizedAt;
'order[createdAt]'?: ApiAdminperformancesGetCollectionOrderCreatedAt;
'order[referenceQuantity]'?: ApiAdminperformancesGetCollectionOrderReferenceQuantity;
'order[amount]'?: ApiAdminperformancesGetCollectionOrderAmount;
'order[point.amount]'?: ApiAdminperformancesGetCollectionOrderPointAmount;
'order[referenceUniqueCode]'?: ApiAdminperformancesGetCollectionOrderReferenceUniqueCode;
};

export type ApiAdminperformancesGetCollectionOrderId = typeof ApiAdminperformancesGetCollectionOrderId[keyof typeof ApiAdminperformancesGetCollectionOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminperformancesGetCollectionOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminperformancesGetCollectionOrderRealizedAt = typeof ApiAdminperformancesGetCollectionOrderRealizedAt[keyof typeof ApiAdminperformancesGetCollectionOrderRealizedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminperformancesGetCollectionOrderRealizedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminperformancesGetCollectionOrderCreatedAt = typeof ApiAdminperformancesGetCollectionOrderCreatedAt[keyof typeof ApiAdminperformancesGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminperformancesGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminperformancesGetCollectionOrderReferenceQuantity = typeof ApiAdminperformancesGetCollectionOrderReferenceQuantity[keyof typeof ApiAdminperformancesGetCollectionOrderReferenceQuantity];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminperformancesGetCollectionOrderReferenceQuantity = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminperformancesGetCollectionOrderAmount = typeof ApiAdminperformancesGetCollectionOrderAmount[keyof typeof ApiAdminperformancesGetCollectionOrderAmount];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminperformancesGetCollectionOrderAmount = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminperformancesGetCollectionOrderPointAmount = typeof ApiAdminperformancesGetCollectionOrderPointAmount[keyof typeof ApiAdminperformancesGetCollectionOrderPointAmount];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminperformancesGetCollectionOrderPointAmount = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminperformancesGetCollectionOrderReferenceUniqueCode = typeof ApiAdminperformancesGetCollectionOrderReferenceUniqueCode[keyof typeof ApiAdminperformancesGetCollectionOrderReferenceUniqueCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminperformancesGetCollectionOrderReferenceUniqueCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminperformancesGetCollection200AllOf = {
  data?: PerformancePerformanceCollectionReadModel[];
};

export type ApiAdminperformancesGetCollection200 = PaginatedResponseModel & ApiAdminperformancesGetCollection200AllOf;

export type ApiAdminpointsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
'attributedToCompany.name'?: string;
'attributedToCompany.uniqueCode'?: string;
label?: string;
type?: number;
'type[]'?: number[];
'addedByUserWorkspace.uniqueCode'?: string;
'addedByUserWorkspace.uniqueCode[]'?: string[];
'amount[between]'?: string;
'amount[gt]'?: string;
'amount[gte]'?: string;
'amount[lt]'?: string;
'amount[lte]'?: string;
'valueDate[before]'?: string;
'valueDate[strictly_before]'?: string;
'valueDate[after]'?: string;
'valueDate[strictly_after]'?: string;
'createdAt[before]'?: string;
'createdAt[strictly_before]'?: string;
'createdAt[after]'?: string;
'createdAt[strictly_after]'?: string;
/**
 * Search in concatenated fields: addedByUserWorkspace.user.firstname   addedByUserWorkspace.user.lastname
 */
'addedByUserWorkspace.user.fullname'?: string;
/**
 * Search in concatenated fields: obtainedBy.user.firstname   obtainedBy.user.lastname
 */
'obtainedBy.user.fullname'?: string;
'order[id]'?: ApiAdminpointsGetCollectionOrderId;
'order[valueDate]'?: ApiAdminpointsGetCollectionOrderValueDate;
'order[amount]'?: ApiAdminpointsGetCollectionOrderAmount;
'order[createdAt]'?: ApiAdminpointsGetCollectionOrderCreatedAt;
};

export type ApiAdminpointsGetCollectionOrderId = typeof ApiAdminpointsGetCollectionOrderId[keyof typeof ApiAdminpointsGetCollectionOrderId];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminpointsGetCollectionOrderId = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminpointsGetCollectionOrderValueDate = typeof ApiAdminpointsGetCollectionOrderValueDate[keyof typeof ApiAdminpointsGetCollectionOrderValueDate];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminpointsGetCollectionOrderValueDate = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminpointsGetCollectionOrderAmount = typeof ApiAdminpointsGetCollectionOrderAmount[keyof typeof ApiAdminpointsGetCollectionOrderAmount];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminpointsGetCollectionOrderAmount = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminpointsGetCollectionOrderCreatedAt = typeof ApiAdminpointsGetCollectionOrderCreatedAt[keyof typeof ApiAdminpointsGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminpointsGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminpointsGetCollection200AllOf = {
  data?: PointPointCollectionReadModel[];
};

export type ApiAdminpointsGetCollection200 = PaginatedResponseModel & ApiAdminpointsGetCollection200AllOf;

export type ApiShopsShopIdproductsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
name?: string;
category?: string;
'category[]'?: string[];
brand?: string;
'brand[]'?: string[];
isActive?: boolean;
'order[createdAt]'?: ApiShopsShopIdproductsGetCollectionOrderCreatedAt;
'order[name]'?: ApiShopsShopIdproductsGetCollectionOrderName;
'order[price]'?: ApiShopsShopIdproductsGetCollectionOrderPrice;
/**
 * Search in name, description, category.label, brand.name
 */
search?: string;
};

export type ApiShopsShopIdproductsGetCollectionOrderCreatedAt = typeof ApiShopsShopIdproductsGetCollectionOrderCreatedAt[keyof typeof ApiShopsShopIdproductsGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiShopsShopIdproductsGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiShopsShopIdproductsGetCollectionOrderName = typeof ApiShopsShopIdproductsGetCollectionOrderName[keyof typeof ApiShopsShopIdproductsGetCollectionOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiShopsShopIdproductsGetCollectionOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiShopsShopIdproductsGetCollectionOrderPrice = typeof ApiShopsShopIdproductsGetCollectionOrderPrice[keyof typeof ApiShopsShopIdproductsGetCollectionOrderPrice];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiShopsShopIdproductsGetCollectionOrderPrice = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiShopsShopIdproductsGetCollection200AllOf = {
  data?: ProductProductReadModel[];
};

export type ApiShopsShopIdproductsGetCollection200 = PaginatedResponseModel & ApiShopsShopIdproductsGetCollection200AllOf;

export type AdminBrandsParams = {
/**
 * Search in name, label
 */
search?: string;
};

export type ApiShopsShopIdbrandsGetCollectionParams = {
/**
 * Retourne les marques ayant au moins un produit actif dans cette catégorie
 */
'products.category'?: string;
/**
 * Retourne les marques ayant au moins un produit actif dans une de ces catégories
 */
'products.category[]'?: string[];
/**
 * Search in name, label
 */
search?: string;
};

export type AdminGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
label?: string;
parent?: string;
'parent[]'?: string[];
};

export type AdminGetCollection200AllOf = {
  data?: ProductCategoryProductCategoryReadModel[];
};

export type AdminGetCollection200 = PaginatedResponseModel & AdminGetCollection200AllOf;

export type ApiShopsShopIdcategoriesGetCollectionParams = {
label?: string;
parent?: string;
'parent[]'?: string[];
};

export type ApiAdminpurchaseProofsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
filename?: string;
comment?: string;
'createdBy.company.name'?: string;
status?: string;
'status[]'?: string[];
/**
 * Search in concatenated fields: createdBy.user.firstname   createdBy.user.lastname
 */
'createdBy.user.fullname'?: string;
'createdAt[before]'?: string;
'createdAt[strictly_before]'?: string;
'createdAt[after]'?: string;
'createdAt[strictly_after]'?: string;
'order[filename]'?: ApiAdminpurchaseProofsGetCollectionOrderFilename;
'order[createdAt]'?: ApiAdminpurchaseProofsGetCollectionOrderCreatedAt;
'order[status]'?: ApiAdminpurchaseProofsGetCollectionOrderStatus;
};

export type ApiAdminpurchaseProofsGetCollectionOrderFilename = typeof ApiAdminpurchaseProofsGetCollectionOrderFilename[keyof typeof ApiAdminpurchaseProofsGetCollectionOrderFilename];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminpurchaseProofsGetCollectionOrderFilename = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminpurchaseProofsGetCollectionOrderCreatedAt = typeof ApiAdminpurchaseProofsGetCollectionOrderCreatedAt[keyof typeof ApiAdminpurchaseProofsGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminpurchaseProofsGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminpurchaseProofsGetCollectionOrderStatus = typeof ApiAdminpurchaseProofsGetCollectionOrderStatus[keyof typeof ApiAdminpurchaseProofsGetCollectionOrderStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminpurchaseProofsGetCollectionOrderStatus = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminpurchaseProofsGetCollection200AllOf = {
  data?: PurchaseProofPurchaseProofCollectionReadModel[];
};

export type ApiAdminpurchaseProofsGetCollection200 = PaginatedResponseModel & ApiAdminpurchaseProofsGetCollection200AllOf;

export type UserPurchaseProofsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
};

export type UserPurchaseProofs200AllOf = {
  data?: PurchaseProofPurchaseProofCollectionReadModel[];
};

export type UserPurchaseProofs200 = PaginatedResponseModel & UserPurchaseProofs200AllOf;

export type ApiReferencesGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
'order[brand]'?: ApiReferencesGetCollectionOrderBrand;
'order[productLine]'?: ApiReferencesGetCollectionOrderProductLine;
'order[name]'?: ApiReferencesGetCollectionOrderName;
'order[uniqueCode]'?: ApiReferencesGetCollectionOrderUniqueCode;
'order[pointValue]'?: ApiReferencesGetCollectionOrderPointValue;
/**
 * Exclude references already boosted from date
 */
'available[startDate]'?: string;
/**
 * Exclude references already boosted until date
 */
'available[endDate]'?: string;
/**
 * Search in tags, brand, name, uniqueCode
 */
search?: string;
};

export type ApiReferencesGetCollectionOrderBrand = typeof ApiReferencesGetCollectionOrderBrand[keyof typeof ApiReferencesGetCollectionOrderBrand];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiReferencesGetCollectionOrderBrand = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiReferencesGetCollectionOrderProductLine = typeof ApiReferencesGetCollectionOrderProductLine[keyof typeof ApiReferencesGetCollectionOrderProductLine];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiReferencesGetCollectionOrderProductLine = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiReferencesGetCollectionOrderName = typeof ApiReferencesGetCollectionOrderName[keyof typeof ApiReferencesGetCollectionOrderName];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiReferencesGetCollectionOrderName = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiReferencesGetCollectionOrderUniqueCode = typeof ApiReferencesGetCollectionOrderUniqueCode[keyof typeof ApiReferencesGetCollectionOrderUniqueCode];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiReferencesGetCollectionOrderUniqueCode = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiReferencesGetCollectionOrderPointValue = typeof ApiReferencesGetCollectionOrderPointValue[keyof typeof ApiReferencesGetCollectionOrderPointValue];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiReferencesGetCollectionOrderPointValue = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiReferencesGetCollection200AllOf = {
  data?: ReferenceReferenceReadModel[];
};

export type ApiReferencesGetCollection200 = PaginatedResponseModel & ApiReferencesGetCollection200AllOf;

export type ApiAdminsalesHierarchyLinksIdDeleteParams = {
/**
 * true (default) cascade-deletes the whole subtree; false reattaches the child's direct reports to the grandparent instead.
 */
cascade?: boolean;
};

export type ApiAdminsegmentsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
/**
 * Search in name, description
 */
search?: string;
};

export type ApiAdminsegmentsGetCollection200AllOf = {
  data?: SegmentSegmentCollectionReadModel[];
};

export type ApiAdminsegmentsGetCollection200 = PaginatedResponseModel & ApiAdminsegmentsGetCollection200AllOf;

export type ApiAdminsegmentsIdmembersGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
};

export type ApiAdminsegmentsIdmembersGetCollection200AllOf = {
  data?: UserWorkspaceSegmentMemberReadModel[];
};

export type ApiAdminsegmentsIdmembersGetCollection200 = PaginatedResponseModel & ApiAdminsegmentsIdmembersGetCollection200AllOf;

export type ApiShopsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
};

export type ApiShopsGetCollection200AllOf = {
  data?: ShopShopReadModel[];
};

export type ApiShopsGetCollection200 = PaginatedResponseModel & ApiShopsGetCollection200AllOf;

export type ApiAdmintypologiesGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
name?: string;
};

export type ApiAdmintypologiesGetCollection200AllOf = {
  data?: TypologyTypologyReadModel[];
};

export type ApiAdmintypologiesGetCollection200 = PaginatedResponseModel & ApiAdmintypologiesGetCollection200AllOf;

export type ApiAdminusersGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
/**
 * Search in concatenated fields: firstname   lastname
 */
fullname?: string;
'status[]'?: ApiAdminusersGetCollectionStatusItem[];
/**
 * Search by phone
 */
phone?: string;
'userWorkspaces.registeredAt[after]'?: string;
'userWorkspaces.registeredAt[strictly_after]'?: string;
'userWorkspaces.registeredAt[before]'?: string;
'userWorkspaces.registeredAt[strictly_before]'?: string;
'order[userWorkspaces.registeredAt]'?: ApiAdminusersGetCollectionOrderUserWorkspacesRegisteredAt;
'order[commercial]'?: ApiAdminusersGetCollectionOrderCommercial;
/**
 * Search in firstname, lastname, email, userWorkspaces.uniqueCode
 */
search?: string;
email?: string;
firstname?: string;
lastname?: string;
'userWorkspaces.uniqueCode'?: string;
'userWorkspaces.company.name'?: string;
'userWorkspaces.comment'?: string;
'userWorkspaces.comment2'?: string;
'userWorkspaces.comment3'?: string;
/**
 * Filter users by role
 */
'maxRole[]'?: ApiAdminusersGetCollectionMaxRoleItem[];
/**
 * Search in concatenated fields: userWorkspaces.company.companyResponsibles.responsible.user.firstname   userWorkspaces.company.companyResponsibles.responsible.user.lastname
 */
responsible_fullname?: string;
'order[firstname]'?: ApiAdminusersGetCollectionOrderFirstname;
'order[lastname]'?: ApiAdminusersGetCollectionOrderLastname;
'order[userWorkspaces.createdAt]'?: ApiAdminusersGetCollectionOrderUserWorkspacesCreatedAt;
'userWorkspaces.createdAt[before]'?: string;
'userWorkspaces.createdAt[strictly_before]'?: string;
'userWorkspaces.createdAt[after]'?: string;
'userWorkspaces.createdAt[strictly_after]'?: string;
};

export type ApiAdminusersGetCollectionStatusItem = typeof ApiAdminusersGetCollectionStatusItem[keyof typeof ApiAdminusersGetCollectionStatusItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminusersGetCollectionStatusItem = {
  userstatusunregistered: 'user.status.unregistered',
  userstatusregistered: 'user.status.registered',
  userstatusblocked: 'user.status.blocked',
  userstatusinactive: 'user.status.inactive',
} as const;

export type ApiAdminusersGetCollectionOrderUserWorkspacesRegisteredAt = typeof ApiAdminusersGetCollectionOrderUserWorkspacesRegisteredAt[keyof typeof ApiAdminusersGetCollectionOrderUserWorkspacesRegisteredAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminusersGetCollectionOrderUserWorkspacesRegisteredAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminusersGetCollectionOrderCommercial = typeof ApiAdminusersGetCollectionOrderCommercial[keyof typeof ApiAdminusersGetCollectionOrderCommercial];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminusersGetCollectionOrderCommercial = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminusersGetCollectionMaxRoleItem = typeof ApiAdminusersGetCollectionMaxRoleItem[keyof typeof ApiAdminusersGetCollectionMaxRoleItem];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminusersGetCollectionMaxRoleItem = {
  ROLE_MEMBER: 'ROLE_MEMBER',
  ROLE_MANAGER: 'ROLE_MANAGER',
  ROLE_SALES_ADMIN: 'ROLE_SALES_ADMIN',
  ROLE_ADMIN: 'ROLE_ADMIN',
  ROLE_FIDDY_ADMIN: 'ROLE_FIDDY_ADMIN',
} as const;

export type ApiAdminusersGetCollectionOrderFirstname = typeof ApiAdminusersGetCollectionOrderFirstname[keyof typeof ApiAdminusersGetCollectionOrderFirstname];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminusersGetCollectionOrderFirstname = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminusersGetCollectionOrderLastname = typeof ApiAdminusersGetCollectionOrderLastname[keyof typeof ApiAdminusersGetCollectionOrderLastname];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminusersGetCollectionOrderLastname = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminusersGetCollectionOrderUserWorkspacesCreatedAt = typeof ApiAdminusersGetCollectionOrderUserWorkspacesCreatedAt[keyof typeof ApiAdminusersGetCollectionOrderUserWorkspacesCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminusersGetCollectionOrderUserWorkspacesCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminusersGetCollection200AllOf = {
  data?: UserUserCollectionReadModel[];
};

export type ApiAdminusersGetCollection200 = PaginatedResponseModel & ApiAdminusersGetCollection200AllOf;

export type ProfileUpdateBody = { [key: string]: unknown };

export type ApiAdminusersIdhistoryGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
};

export type ApiAdminusersIdhistoryGetCollection200AllOf = {
  data?: UserHistoryUserHistoryReadModel[];
};

export type ApiAdminusersIdhistoryGetCollection200 = PaginatedResponseModel & ApiAdminusersIdhistoryGetCollection200AllOf;

export type ApiAdminusersIdloginHistoryGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
};

export type ApiAdminusersIdloginHistoryGetCollection200AllOf = {
  data?: UserHistoryLoginUserHistoryLoginReadModel[];
};

export type ApiAdminusersIdloginHistoryGetCollection200 = PaginatedResponseModel & ApiAdminusersIdloginHistoryGetCollection200AllOf;

export type ApiAdminvideoNoticesGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
};

export type ApiAdminvideoNoticesGetCollection200AllOf = {
  data?: VideoNoticeVideoNoticeCollectionReadModel[];
};

export type ApiAdminvideoNoticesGetCollection200 = PaginatedResponseModel & ApiAdminvideoNoticesGetCollection200AllOf;

export type ApiAdminwaitingListsGetCollectionParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
email?: string;
firstname?: string;
lastname?: string;
companyName?: string;
'createdBy.uniqueCode'?: string;
status?: string;
'status[]'?: string[];
'createdAt[before]'?: string;
'createdAt[strictly_before]'?: string;
'createdAt[after]'?: string;
'createdAt[strictly_after]'?: string;
'order[createdAt]'?: ApiAdminwaitingListsGetCollectionOrderCreatedAt;
};

export type ApiAdminwaitingListsGetCollectionOrderCreatedAt = typeof ApiAdminwaitingListsGetCollectionOrderCreatedAt[keyof typeof ApiAdminwaitingListsGetCollectionOrderCreatedAt];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ApiAdminwaitingListsGetCollectionOrderCreatedAt = {
  asc: 'asc',
  desc: 'desc',
} as const;

export type ApiAdminwaitingListsGetCollection200AllOf = {
  data?: WaitingListWaitingListReadModel[];
};

export type ApiAdminwaitingListsGetCollection200 = PaginatedResponseModel & ApiAdminwaitingListsGetCollection200AllOf;

export type ValidateWorkspaceConfigurationBody = { [key: string]: unknown };

export type AdminWorkspaceConfigsParams = {
/**
 * The collection page number
 */
page?: number;
/**
 * The number of items per page
 * @minimum 0
 * @maximum 30
 */
perPage?: number;
'config.type'?: string;
'config.type[]'?: string[];
'config.key'?: string;
'config.key[]'?: string[];
};

export type AdminWorkspaceConfigs200AllOf = {
  data?: WorkspaceConfigWorkspaceConfigReadModel[];
};

export type AdminWorkspaceConfigs200 = PaginatedResponseModel & AdminWorkspaceConfigs200AllOf;

